/********************************* Utility Functions *********************/

// convert string of date to human-readable format
function dateToString(dateString) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const [year, month, day] = dateString.split('-');
    const date = new Date(Date.UTC(year, month - 1, day));
    return `${months[date.getUTCMonth()]} ${date.getUTCDate()} ${date.getUTCFullYear()}`;
}

// push date object X days
function pushDate(date, days) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate.toISOString().split('T')[0];
}

// logout function
function logout() {
    localStorage.removeItem("recharge_session");
    window.location.href = "/account/logout?return_url=%2Faccount%2Flogin";
}

// function to take mongodb utc to MM/DD/YYYY
function mongoDateToHuman(date) {
    return new Date(parseInt(date["$date"]["$numberLong"])).toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

// refresh cad pricing
async function refreshSubscriptionPrice(subscriptionID) {
    await fetch(`${root}/portal/refresh-subscription-price.php`, {
        method: "POST",
        body: new URLSearchParams({
            subscriptionID: subscriptionID
        })
    });
    return true;
}

/*************************** Global Variables ***************************/

// get url params
const urlParams = new URLSearchParams(window.location.search);

// us variant ids
const rollsVariantsUS = [handleToVariantID["16-rolls"], handleToVariantID["32-rolls"], handleToVariantID["96-rolls"]];
const bundlesVariantsUS = [handleToVariantID["16-rolls-4-boxes"], handleToVariantID["32-rolls-8-boxes"]];
const tissueVariantUS = handleToVariantID["12-boxes"];

// ca variant ids
const rollsVariantsCA = [handleToVariantID["16-rolls-ca"], handleToVariantID["32-rolls-ca"], handleToVariantID["96-rolls-ca"]];
const bundlesVariantsCA = [handleToVariantID["16-rolls-4-boxes-ca"], handleToVariantID["32-rolls-8-boxes-ca"]];
const tissueVariantCA = handleToVariantID["12-boxes-ca"];

// cadence options
const cadences = [6, 9, 12, 18, 24];

// banned states
const bannedProvinces = [
    "alaska",
    "american samoa",
    "micronesia",
    "guam",
    "hawaii",
    "marshall islands",
    "northern mariana islands",
    "palau",
    "puerto rico",
    "virgin islands",
    "armed forces"
];

/******************************** Reactivate Subscription *********************/

// General Reactivate Flow - https://plantpaper.us/account/?reactivate=true
// 10% Reactivate Flow - https://plantpaper.us/account/?reactivate=10

// check for reactivate query string
if (urlParams.get("reactivate")) {
    sessionStorage.setItem("reactivate", urlParams.get("reactivate"));
    window.history.replaceState({}, document.title, window.location.pathname);
}

/******************************* Tissue Popup *****************************/

// Example: https://plantpaper.us/account/?spacer

// check for tissue popup query string
if (urlParams.has("tissue_popup")) {
    sessionStorage.setItem("tissue_popup", "true");
    window.history.replaceState({}, document.title, window.location.pathname);
}

/******************** Check for back button *****************/

if (performance.navigation.type === 2) {
    window.location.reload();
    throw new Error("Refreshing due to back button");
}

/******************** Recharge Setup / Variables ********************/

// start recharge
recharge.init({
    storefrontAccessToken: 'strfnt_383881b23003928358e7be0dad07b9118f2a096156434597cb023f03011c1938',
});

// recharge auth object
let session;

/****************************** Portal Start ********************/

// setup portal
let customer, subscriptions, addresses, paymentMethods;

async function setupPortal() {
    // determine if we're in via shopify or localstorage
    if (["/pages/subscription-portal", "/pages/subscription-portal/"].includes(window.location.pathname)) {
        session = JSON.parse(localStorage.getItem("recharge_session"));
    } else if (["/account", "/account/", "/account.ogin"].includes(window.location.pathname)) {
        session = await recharge.auth.loginShopifyAppProxy();
    } else {
        // generic error
        await Swal.fire({
            icon: "warning",
            title: "It doesn't look like you're logged in. Let's try again.",
        });
        logout();
        return;
    }

    // get customer
    try {
        customer = await recharge.customer.getCustomer(session);
    } catch (e) {
        // GA4 errors
        gtag('event', 'portal_error_login_customer');

        // check for not logged in
        if (e.message === "Not logged in.") {
            await Swal.fire({
                icon: "warning",
                title: "This email is not associated with any current or past subscription.",
                html: `Please click <a href="/pages/plant-paper"><u>here</u></a> to set up a new subscription.`
            });
        } else {
            await Swal.fire({
                icon: "warning",
                title: "We're having an issue accessing your account.",
                text: "Please refresh and try again otherwise contact info@plantpaper.us with error code P1."
            });
        }

        logout();
        return;
    }

    // get addresses, subscriptions and payment methods
    try {


        await Promise.all([
            recharge.subscription.listSubscriptions(session, {
                limit: 25,
                sort_by: 'id-desc',
            }),
            recharge.address.listAddresses(session),
            recharge.paymentMethod.listPaymentMethods(session),
        ])
            .then(response => {
                subscriptions = response[0].subscriptions;
                addresses = response[1].addresses;
                paymentMethods = response[2].payment_methods;
            });


    } catch (e) {
        // GA4 errors
        gtag('event', 'portal_error_login');

        // generic error
        await Swal.fire({
            icon: "warning",
            title: "We're having an issue accessing your account.",
            text: "Please refresh and try again otherwise contact info@plantpaper.us with error code P1."
        });

        logout();
        return;
    }

    // GA4 login
    gtag('event', 'portal_login');

    try {
        // identify
        klaviyo.identify({
            '$email': customer.email,
        })
            .then(() => {
                // track
                klaviyo.push(["track", "Portal Login | MalterTech"]);
            });
    } catch (e) {
        // do nothing
    }

    // setup intro
    document.querySelector("#introName").textContent = `Welcome ${customer.first_name ?? ""},`;

    // setup intro close
    document.querySelector("#introAnnouncementClose").addEventListener("click", function () {
        document.querySelector("#introAnnouncement").classList.remove("active");
        document.querySelector("#introOpen").classList.add("active");
    });

    // setup intro open
    document.querySelector("#introOpen").addEventListener("click", function () {
        document.querySelector("#introAnnouncement").classList.add("active");
        document.querySelector("#introOpen").classList.remove("active");
    });

    // are they a legacy subscriber
    let isLegacy = false;
    subscriptions.forEach(subscription => {
        // check if they're active
        if (subscription.status !== "active") return;

        // parse their price
        let currentSubscriptionPrice = parseFloat(subscription.price) * 100;

        // find product in our matrix
        let product = products[subscription.external_variant_id.ecommerce];

        // check if this option is their current product and check if their price is lower than retail
        if (currentSubscriptionPrice < product.subscription_price) {
            isLegacy = true;
        }
    });

    // check if they're a legacy subscriber
    if (isLegacy || localStorage.getItem("isLegacy")) {
        document.querySelector("#introAnnouncement").classList.add("warning");
        document.querySelector("#introAnnouncementBody").insertAdjacentHTML("beforeend", `<br><br>Hi Planter. You currently have a legacy discount on your subscription. If you add tissues to your subscription to make it a bundle, or switch into another pack size, rest assured your discount will be retained, but the discounted price will not immediately be reflected in your portal.`);
    }

    // determine their country experience (US or CA) - must have 1 active CA subscription to be CA
    let countryExperience = "US";
    if (subscriptions.filter(subscription => subscription.status === "active" && subscription.presentment_currency === "CAD").length > 0) {
        countryExperience = "CA";
    }

    // add customer id for css overrides
    document.querySelector("#portal").setAttribute("data-recharge-customer-id", customer.id);

    // append list of subscriptions to intro header
    subscriptions.forEach((subscription) => {
        // function to render subscription
        async function renderSubscription(target = null, refreshData = false, updated = []) {
            // check if we need to refresh data
            if (refreshData) {
                // fetch customer, addresses and subscriptions
                subscriptions = (await recharge.subscription.listSubscriptions(session, {
                    limit: 25,
                    sort_by: 'id-desc',
                })).subscriptions;
                addresses = (await recharge.address.listAddresses(session)).addresses;
                paymentMethods = (await recharge.paymentMethod.listPaymentMethods(session)).payment_methods;

                // update the subscription from the refreshed data so it's in sync
                subscription = subscriptions.find(sub => sub.id === subscription.id);

                // refresh tissues
                setupEligibleTissueOffers();
            }

            // find the corresponding address for this subscription
            let address = addresses.filter(address => address.id === subscription.address_id)[0];

            // find the payment method id
            let paymentMethod = paymentMethods.filter(payment_method => payment_method.id === address.payment_method_id)[0];

            // check if no payment method
            if (!paymentMethod) {
                return;
            }

            // find product in our matrix
            let product = products[subscription.external_variant_id.ecommerce];

            // parse their price
            let currentSubscriptionPrice = parseFloat(subscription.price) * 100;

            // function to plan HTML
            function planHTML() {
                // function to generate option HTML based on the variant
                function optionHTML(variantID) {
                    // default price
                    let retailPrice = price(products[variantID].subscription_price);

                    // check if this option is the current subscription
                    let isActiveProduct = variantID === product.variant_id;

                    // check if this option is their current product and check if their price is lower than retail
                    if (isActiveProduct && currentSubscriptionPrice < product.subscription_price) {
                        retailPrice = `Legacy - ${price(currentSubscriptionPrice)}`
                    }

                    // return HTML
                    return `
                        <option value="${variantID}" ${isActiveProduct ? "selected" : ""}>
                            ${products[variantID].modify_title} (${retailPrice})
                        </option>
                    `;
                }

                // html string
                let HTML = "";

                // check for USA plan
                if (rollsVariantsUS.includes(product.variant_id) || bundlesVariantsUS.includes(product.variant_id)) {
                    // add base plans and select their current variant
                    rollsVariantsUS.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });

                    // add add-ons and select their current variant
                    HTML += `<optgroup label="Tissue bundles:">`;
                    bundlesVariantsUS.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });
                    HTML += `</optgroup>`;
                }
                // check for CA plan
                else if (rollsVariantsCA.includes(product.variant_id) || bundlesVariantsCA.includes(product.variant_id)) {
                    rollsVariantsCA.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });

                    // add add-ons and select their current variant
                    HTML += `<optgroup label="Tissue bundles:">`;
                    bundlesVariantsCA.forEach(variantID => {
                        HTML += optionHTML(variantID);
                    });
                    HTML += `</optgroup>`;
                }
                // return their current variant
                else {
                    HTML += `<option value="${product.variant_id}">${product.modify_title} (${price(currentSubscriptionPrice)})</option>`;
                }

                return HTML;
            }

            // function for cadence html
            function cadenceHTML() {
                let HTML = "";

                // check if we have a custom cadence
                if (!cadences.includes(subscription.order_interval_frequency)) {
                    HTML += `<option value="${subscription.order_interval_frequency}" selected>Every ${subscription.order_interval_frequency} ${subscription.order_interval_unit}</option>`;
                }

                // generate HTML
                cadences.forEach(cadence => {
                    HTML += `<option value="${cadence}" ${cadence === subscription.order_interval_frequency ? "selected" : ""}>Every ${cadence} weeks</option>`;
                });

                return HTML;
            }

            // function for next delivery date html
            function nextDeliveryDateHTML() {
                // active subscription with no next charge date means the payment method faild
                if (subscription.status === "active" && subscription.next_charge_scheduled_at) {
                    return dateToString(subscription.next_charge_scheduled_at);
                } else if (subscription.status === "active") {
                    return "Payment Failed"
                } else {
                    return "N/A";
                }
            }

            // address html
            function addressHTML() {
                let HTML = "";

                // loop through addresses
                addresses.forEach(address => {
                    HTML += `<option value="${address.id}" ${address.id === subscription.address_id ? "selected" : ""}>${address.address1}</option>`;
                });

                return HTML;
            }

            // create the subscription HTML (only show active by default)
            let HTML = `
                <div class="portalSubscriptionsGridItem ${subscription.status === "active" ? "active" : ""}" data-id="${subscription.id}" data-status="${subscription.status}">
                    <div class="portalSubscriptionsGridItemHeader">
                        <img class="portalSubscriptionsGridItemHeaderImage" src="${product.featured_image}">
                        <div class="portalSubscriptionsGridItemHeaderTitle">${subscription.quantity > 1 ? `${subscription.quantity} x ` : ""} ${product.title}</div>
                        <div class="portalSubscriptionsGridItemHeaderGeneral">
                            <div class="portalSubscriptionsGridItemHeaderGeneralCurrent">Delivered every <span class="portalSubscriptionsGridItemHeaderGeneralCurrentModify">${subscription.order_interval_frequency} ${subscription.order_interval_unit}${subscription.order_interval_frequency > 1 ? "s" : ""}</span></div>
                            <button class="portalSubscriptionsGridItemHeaderGeneralModify">
                                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path id="images 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M3.60831 18.896L7.17305 17.7576L13.9218 11.3272C17.7752 7.65557 20.7431 4.73752 20.8398 4.52562C21.072 4.01646 21.052 3.52517 20.7783 3.01774C20.4904 2.48413 18.1532 0.279293 17.7017 0.115378C17.2395 -0.052343 16.6029 -0.0358463 16.1415 0.155983C15.9188 0.248496 12.8799 3.07 9.02889 6.75986L2.3053 13.2021L1.1316 16.5834C0.486074 18.443 -0.0227776 19.9803 0.000787735 19.9995C0.0243511 20.0186 1.6477 19.522 3.60831 18.896ZM3.21606 15.9383L3.67114 14.6409L4.62891 15.5606C5.29703 16.2021 5.53423 16.4992 5.41327 16.5426C4.45394 16.8862 2.81633 17.364 2.79192 17.3074C2.775 17.2679 2.96581 16.6518 3.21606 15.9383ZM5.86727 14.3205L4.68691 13.1895L5.20495 12.7451C5.48989 12.5007 7.57182 10.5477 9.8315 8.40501L13.94 4.50912L15.1484 5.59412L16.3568 6.67912L11.7655 11.0654C9.24036 13.4777 7.14574 15.4515 7.11094 15.4515C7.07614 15.4515 6.51653 14.9426 5.86727 14.3205ZM16.0825 2.44767L16.9557 1.60861L18.0761 2.67365C18.6924 3.2594 19.1965 3.79037 19.1965 3.85346C19.1965 3.91656 18.8307 4.32018 18.3835 4.75021L17.5706 5.53229L16.39 4.40957L15.2094 3.28674L16.0825 2.44767Z" fill="#414141" fill-opacity="0.5"/>
                                </svg>
                                Modify Subscription
                            </button>
                        </div>
                        <div class="portalSubscriptionsGridItemHeaderUpdated">
                            <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                            </svg>
                            Subscription Updated
                        </div>
                    </div>
                    <div class="portalSubscriptionsGridItemPadding">
                        <div class="portalSubscriptionsGridItemModify">
                            <div class="portalSubscriptionsGridItemModifyTitle">Modify your subscription:</div>
                            <div class="portalSubscriptionsGridItemModifyForm">
                                <select class="portalSubscriptionsGridItemModifyFormVariant">${planHTML()}</select>
                                <select class="portalSubscriptionsGridItemModifyFormCadence">${cadenceHTML()}</select>
                            </div>
                            <div class="portalSubscriptionsGridItemModifyActions">
                                <button class="portalSubscriptionsGridItemModifyActionsSave portalButton primary">Update Subscription</button>
                                <button class="portalSubscriptionsGridItemModifyActionsCancel">No thanks, leave as-is</button>
                            </div>
                            <button class="portalSubscriptionsGridItemModifyExit">
                                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Group 876">
                                        <line id="Line 806" x1="0.176777" y1="0.823223" x2="14.1768" y2="14.8232" stroke="black" stroke-width="0.5"/>
                                        <line id="Line 807" x1="14.1768" y1="1.17678" x2="0.176777" y2="15.1768" stroke="black" stroke-width="0.5"/>
                                    </g>
                                </svg>
                            </button>
                        </div>
                        <div class="portalSubscriptionsGridItemResume ${subscription.status === "cancelled" ? "active" : ""}">
                            <div class="portalSubscriptionsGridItemResumeLabel portalButton">Inactive</div>
                            <button class="portalSubscriptionsGridItemResumeNow portalButton">Re-activate</button>
                        </div>
                        <div class="portalSubscriptionsGridItemDelivery ${subscription.status === "active" ? "active" : ""}">
                            <div class="portalSubscriptionsGridItemDeliveryTitle">
                                Next Order Date:
                                <div class="portalSubscriptionsGridItemDeliveryTitleUpdated">
                                    <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                    </svg>
                                    Order Date Updated
                                </div> 
                            </div>
                            <div class="portalSubscriptionsGridItemDeliveryDate">${nextDeliveryDateHTML()}</div>
                            <button class="portalSubscriptionsGridItemDeliveryModify">
                                or choose next order date:
                                <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Group 853">
                                        <rect id="Rectangle 35" width="30.5108" height="25.622" fill="#414141" fill-opacity="0.23"/>
                                        <line id="Line 87" y1="4.71045" x2="30.5108" y2="4.71045" stroke="white"/>
                                        <line id="Line 91" y1="11.6602" x2="30.5108" y2="11.6602" stroke="white"/>
                                        <line id="Line 92" y1="18.6074" x2="30.5108" y2="18.6074" stroke="white"/>
                                        <path id="Line 88" d="M7.34375 25.6221L7.34375 5.21136" stroke="white"/>
                                        <path id="Line 89" d="M15.6367 25.6221L15.6367 5.21136" stroke="white"/>
                                        <path id="Line 90" d="M23.5391 25.6221L23.5391 5.21136" stroke="white"/>
                                    </g>
                                </svg>
                            </button>
                            <div class="portalSubscriptionsGridItemDeliveryReschedule">
                                <button class="portalSubscriptionsGridItemDeliveryRescheduleNow portalButton primary">Ship my order now</button>
                                <button class="portalSubscriptionsGridItemDeliveryRescheduleWeek portalButton">Push back 1 week</button>
                                <button class="portalSubscriptionsGridItemDeliveryRescheduleMonth portalButton">Push back 1 month</button>
                            </div>
                        </div>
                        <div class="portalSubscriptionsGridItemAddress">
                            <div class="portalSubscriptionsGridItemAddressCurrent active">                        
                                <div class="portalSubscriptionsGridItemAddressCurrentLabel">
                                    Delivered to:
                                    <div class="portalSubscriptionsGridItemAddressCurrentLabelUpdated">
                                        <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                        </svg>
                                        Address Updated
                                    </div>
                                </div>
                                <div class="portalSubscriptionsGridItemAddressCurrentName">
                                    <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="795_home 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M5.2511 5.31248L0.0128082 10.625L0.00642321 10.9783L0 11.3317L1.30147 11.3316H2.60298L2.61267 14.656L2.6224 17.9803H5.90989H9.19739L9.20724 15.9852L9.21708 13.99L10.4994 14.0002L11.7818 14.0104L11.7896 15.9953L11.7974 17.9803L15.0866 17.9902L18.3758 18V14.6649V11.3297L19.6775 11.3327L20.9792 11.3357L20.9896 10.9964L21 10.6571L19.0228 8.65302L17.0456 6.64889V3.64753V0.646176L16.9601 0.669418C16.9131 0.682176 16.3145 0.69289 15.6299 0.69316L14.3852 0.6937V2.32199V3.95033L12.4373 1.97514L10.4894 0L5.2511 5.31248Z" fill="#FF9417"/>
                                    </svg>
                                    ${address.address1}
                                </div>
                                <button class="portalSubscriptionsGridItemAddressCurrentModify">
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="images 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M3.60831 18.896L7.17305 17.7576L13.9218 11.3272C17.7752 7.65557 20.7431 4.73752 20.8398 4.52562C21.072 4.01646 21.052 3.52517 20.7783 3.01774C20.4904 2.48413 18.1532 0.279293 17.7017 0.115378C17.2395 -0.052343 16.6029 -0.0358463 16.1415 0.155983C15.9188 0.248496 12.8799 3.07 9.02889 6.75986L2.3053 13.2021L1.1316 16.5834C0.486074 18.443 -0.0227776 19.9803 0.000787735 19.9995C0.0243511 20.0186 1.6477 19.522 3.60831 18.896ZM3.21606 15.9383L3.67114 14.6409L4.62891 15.5606C5.29703 16.2021 5.53423 16.4992 5.41327 16.5426C4.45394 16.8862 2.81633 17.364 2.79192 17.3074C2.775 17.2679 2.96581 16.6518 3.21606 15.9383ZM5.86727 14.3205L4.68691 13.1895L5.20495 12.7451C5.48989 12.5007 7.57182 10.5477 9.8315 8.40501L13.94 4.50912L15.1484 5.59412L16.3568 6.67912L11.7655 11.0654C9.24036 13.4777 7.14574 15.4515 7.11094 15.4515C7.07614 15.4515 6.51653 14.9426 5.86727 14.3205ZM16.0825 2.44767L16.9557 1.60861L18.0761 2.67365C18.6924 3.2594 19.1965 3.79037 19.1965 3.85346C19.1965 3.91656 18.8307 4.32018 18.3835 4.75021L17.5706 5.53229L16.39 4.40957L15.2094 3.28674L16.0825 2.44767Z" fill="#414141" fill-opacity="0.5"/>
                                    </svg>
                                    Change Address
                                </button>
                            </div>
                            <div class="portalSubscriptionsGridItemAddressEdit">
                                <div class="portalSubscriptionsGridItemAddressEditLabel">Modify address:</div>
                                <select class="portalSubscriptionsGridItemAddressEditSelect">
                                    ${addressHTML()}
                                    <option value="new">Add a new address</option>
                                </select>
                                <form class="portalSubscriptionsGridItemAddressEditForm">
                                    <input type="text" name="first_name" placeholder="First Name" aria-label="First Name" required>
                                    <input type="text" name="last_name" placeholder="Last Name" aria-label="Last Name" required>
                                    <input type="text" name="address1" placeholder="Address Line 1" aria-label="Address Line 1" required>
                                    <input type="text" name="address2" placeholder="Address Line 2" aria-label="Address Line 2">
                                    <input type="text" name="city" placeholder="City" aria-label="City" required>
                                    <input type="text" name="province" placeholder="State" aria-label="State" required>
                                    <input type="text" name="zip" placeholder="ZIP code" aria-label="ZIP code" required>
                                    <select name="country_code" aria-label="Country Code" required">
                                        <option selected disabled>Country</option>
                                        <option value="US">United States</option>
                                        <option value="CA">Canada</option>
                                    </select>
                                    <input type="tel" name="phone" placeholder="Phone number" aria-label="Phone number" required>
                                    <button class="portalSubscriptionsGridItemAddressEditFormSave portalButton primary">Update Address</button>
                                    <button class="portalSubscriptionsGridItemAddressEditFormCancel" type="button">No thanks, leave as-is</button>
                                    <button class="portalSubscriptionsGridItemAddressEditFormExit" type="button">
                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Group 876">
                                                <line id="Line 806" x1="0.176777" y1="0.823223" x2="14.1768" y2="14.8232" stroke="black" stroke-width="0.5"/>
                                                <line id="Line 807" x1="14.1768" y1="1.17678" x2="0.176777" y2="15.1768" stroke="black" stroke-width="0.5"/>
                                            </g>
                                        </svg>
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div class="portalSubscriptionsGridItemPayment">
                            <div class="portalSubscriptionsGridItemPaymentCurrent active">
                                <div class="portalSubscriptionsGridItemPaymentCurrentLabel">
                                    Payment method:
                                    <div class="portalSubscriptionsGridItemPaymentCurrentLabelUpdated">
                                        <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.5" cy="11.5" r="11.5" fill="#153BFE"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M20 8.20605L9.60847 18L3 11.7716L5.34065 9.56551L9.60847 13.5879L17.6594 6L20 8.20605Z" fill="white"/>
                                        </svg>
                                        Payment Updated
                                    </div>
                                </div>
                                <div class="portalSubscriptionsGridItemPaymentCurrentName">
                                    <svg width="28" height="17" viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Group 873">
                                            <rect id="Rectangle 1905" width="28" height="17" rx="2" fill="#D9D9D9" fill-opacity="0.47"/>
                                            <rect id="Rectangle 1906" y="4" width="28" height="3" fill="#D9D9D9"/>
                                        </g>
                                    </svg>
                                    **** **** **** **** ${paymentMethod.payment_details.last4}
                                </div>
                                <button class="portalSubscriptionsGridItemPaymentCurrentModify">
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path id="images 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M3.60831 18.896L7.17305 17.7576L13.9218 11.3272C17.7752 7.65557 20.7431 4.73752 20.8398 4.52562C21.072 4.01646 21.052 3.52517 20.7783 3.01774C20.4904 2.48413 18.1532 0.279293 17.7017 0.115378C17.2395 -0.052343 16.6029 -0.0358463 16.1415 0.155983C15.9188 0.248496 12.8799 3.07 9.02889 6.75986L2.3053 13.2021L1.1316 16.5834C0.486074 18.443 -0.0227776 19.9803 0.000787735 19.9995C0.0243511 20.0186 1.6477 19.522 3.60831 18.896ZM3.21606 15.9383L3.67114 14.6409L4.62891 15.5606C5.29703 16.2021 5.53423 16.4992 5.41327 16.5426C4.45394 16.8862 2.81633 17.364 2.79192 17.3074C2.775 17.2679 2.96581 16.6518 3.21606 15.9383ZM5.86727 14.3205L4.68691 13.1895L5.20495 12.7451C5.48989 12.5007 7.57182 10.5477 9.8315 8.40501L13.94 4.50912L15.1484 5.59412L16.3568 6.67912L11.7655 11.0654C9.24036 13.4777 7.14574 15.4515 7.11094 15.4515C7.07614 15.4515 6.51653 14.9426 5.86727 14.3205ZM16.0825 2.44767L16.9557 1.60861L18.0761 2.67365C18.6924 3.2594 19.1965 3.79037 19.1965 3.85346C19.1965 3.91656 18.8307 4.32018 18.3835 4.75021L17.5706 5.53229L16.39 4.40957L15.2094 3.28674L16.0825 2.44767Z" fill="#414141" fill-opacity="0.5"/>
                                    </svg>
                                    Edit Payment
                                </button>
                            </div>
                            <div class="portalSubscriptionsGridItemPaymentEdit">
                                <div class="portalSubscriptionsGridItemPaymentEditLabel">Modify payment method:</div>
                                <form class="portalSubscriptionsGridItemPaymentEditForm">
                                    <input type="number" name="cc_number" placeholder="Credit Card Number" aria-label="Credit Card Number" required>
                                    <select name="cc_exp_month" aria-label="Expiration Month" required>
                                        <option selected disabled value="">Expiration Month</option>
                                        <option value="01">Jan (01)</option>
                                        <option value="02">Feb (02)</option>
                                        <option value="03">Mar (03)</option>
                                        <option value="04">Apr (04)</option>
                                        <option value="05">May (05)</option>
                                        <option value="06">Jun (06)</option>
                                        <option value="07">Jul (07)</option>
                                        <option value="08">Aug (08)</option>
                                        <option value="09">Sep (09)</option>
                                        <option value="10">Oct (10)</option>
                                        <option value="11">Nov (11)</option>
                                        <option value="12">Dec (12)</option>
                                    </select>
                                    <select name="cc_exp_year" aria-label="Expiration Year" required>
                                        <option selected disabled value="">Expiration Year</option>
                                        <option value="2023">2023</option>
                                        <option value="2024">2024</option>
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                        <option value="2027">2027</option>
                                        <option value="2028">2028</option>
                                        <option value="2029">2029</option>
                                        <option value="2030">2030</option>
                                        <option value="2031">2031</option>
                                        <option value="2032">2032</option>
                                        <option value="2033">2033</option>
                                        <option value="2034">2034</option>
                                        <option value="2035">2035</option>
                                        <option value="2036">2036</option>
                                        <option value="2037">2037</option>
                                        <option value="2038">2038</option>
                                        <option value="2039">2039</option>
                                        <option value="2040">2040</option>
                                    </select>
                                    <input type="number" name="cc_cvc" placeholder="CVC" aria-label="CVC" required>
                                    <button class="portalSubscriptionsGridItemPaymentEditFormSave portalButton primary">Update Payment Method</button>
                                    <button class="portalSubscriptionsGridItemPaymentEditFormCancel" type="button">No thanks, leave as-is</button>
                                    <button class="portalSubscriptionsGridItemPaymentEditFormExit" type="button">
                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Group 876">
                                                <line id="Line 806" x1="0.176777" y1="0.823223" x2="14.1768" y2="14.8232" stroke="black" stroke-width="0.5"/>
                                                <line id="Line 807" x1="14.1768" y1="1.17678" x2="0.176777" y2="15.1768" stroke="black" stroke-width="0.5"/>
                                            </g>
                                        </svg>
                                    </button>
                                </form>                            
                            </div>
                    </div>
                </div>
            `;

            // check if we have a target, if so replace the content, otherwise append
            if (target) {
                target.outerHTML = HTML;
            } else {
                document.querySelector("#portalSubscriptionsGrid").insertAdjacentHTML("beforeend", HTML);
            }

            // add event listeners, save item
            let item = document.querySelector(`.portalSubscriptionsGridItem[data-id="${subscription.id}"]`);

            /********* Functions *********/

            // function to close all open forms
            function closeAllForms() {
                // close actions
                item.querySelector(".portalSubscriptionsGridItemModifyActionsCancel").click();

                // close address
                item.querySelector(".portalSubscriptionsGridItemAddressEditFormCancel").click();

                // close payment
                item.querySelector(".portalSubscriptionsGridItemPaymentEditFormCancel").click();
            }

            /******* Update Badge ********/

            // check if something was updated
            if (updated.includes("product")) {
                item.querySelector(".portalSubscriptionsGridItemHeaderUpdated").classList.add("active");
            }
            if (updated.includes("date")) {
                item.querySelector(".portalSubscriptionsGridItemDeliveryTitleUpdated").classList.add("active");

                // add updated class to the delivery date to indicate it was changed
                document.querySelector(".portalSubscriptionsGridItemDeliveryDate").classList.add("updated");

                // remove the primary class from the Send Now button since they just changed the date
                item.querySelector(".portalSubscriptionsGridItemDeliveryRescheduleNow").classList.remove("primary");
            }
            if (updated.includes("address")) {
                item.querySelector(".portalSubscriptionsGridItemAddressCurrentLabelUpdated").classList.add("active");
            }
            if (updated.includes("payment")) {
                item.querySelector(".portalSubscriptionsGridItemPaymentCurrentLabelUpdated").classList.add("active");
            }

            /***** Header ******/

            // open modify subscription
            item.querySelectorAll(".portalSubscriptionsGridItemHeaderGeneralCurrentModify,.portalSubscriptionsGridItemHeaderGeneralModify").forEach(element => element.addEventListener("click", function () {
                // close all forms
                closeAllForms();

                // open form
                item.querySelector(".portalSubscriptionsGridItemModify").classList.add("active");
            }));

            /****** Modify ******/

            // update subscription (rolls/frequency)
            item.querySelector(".portalSubscriptionsGridItemModifyActionsSave").addEventListener("click", async function () {
                // list of updated items
                let updated = [];

                // get currently selected variant and cadence
                let variant = item.querySelector(".portalSubscriptionsGridItemModifyFormVariant").value;
                let variantInt = parseInt(variant);
                let cadence = item.querySelector(".portalSubscriptionsGridItemModifyFormCadence").value;

                // update object
                let updatePayload = {};

                // check if variant is different
                if (variantInt !== product.variant_id) {
                    // GA4 change variant
                    gtag('event', 'portal_change_variant');

                    updatePayload.use_external_variant_defaults = true;
                    updatePayload.external_variant_id = {
                        ecommerce: variant
                    };
                    updated.push("product");
                }

                // check if frequency is different
                if (parseInt(cadence) !== subscription.order_interval_frequency) {
                    // GA4 change cadence
                    gtag('event', 'portal_change_cadence');

                    updatePayload.order_interval_frequency = cadence;
                    updatePayload.charge_interval_frequency = cadence;
                    updatePayload.order_interval_unit = "week";
                    updated.push("date");
                }

                // no change
                if (Object.keys(updatePayload).length === 0) {
                    await Swal.fire({
                        "icon": "error",
                        "title": "No change detected to your subscription."
                    });
                    return;
                }

                // start loading
                this.classList.add("loading");

                // save old subscription
                let currentNextChargeDate = subscription.next_charge_scheduled_at;

                // update subscription
                subscription = await recharge.subscription.updateSubscription(
                    session,
                    subscription.id,
                    updatePayload
                );

                // check if the next charge date changed
                if (currentNextChargeDate !== subscription.next_charge_scheduled_at) {
                    // ask the user if they want to update the next charge date to the old or new charge date since it changes when you change the frequency
                    let date = await openDeliveryModal(currentNextChargeDate, subscription.next_charge_scheduled_at);

                    // update the charge date if the date is different
                    if (date !== subscription.next_charge_scheduled_at) {
                        subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, date);
                    }
                }

                // refresh subscription pricing if the variant changed
                if (variantInt !== product.variant_id) {
                    await refreshSubscriptionPrice(subscription.id);
                }

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, true, updated);
            });

            // cancel modify subscription
            item.querySelectorAll(".portalSubscriptionsGridItemModifyActionsCancel,.portalSubscriptionsGridItemModifyExit").forEach(element => element.addEventListener("click", function () {
                // close modify container
                item.querySelector(".portalSubscriptionsGridItemModify").classList.remove("active");

                // reset variant and cadence
                item.querySelector(".portalSubscriptionsGridItemModifyFormVariant").value = product.variant_id;
                item.querySelector(".portalSubscriptionsGridItemModifyFormCadence").value = subscription.order_interval_frequency;
            }));

            /****** Resume ******/

            // resume subscription
            item.querySelector(".portalSubscriptionsGridItemResumeNow").addEventListener("click", async function () {
                // GA4 resume subscription
                gtag('event', 'portal_resume_subscription');

                // start loading
                this.classList.add("loading");

                subscription = await recharge.subscription.activateSubscription(session, subscription.id);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, true, []);

                // success
                await Swal.fire({
                    icon: "success",
                    title: "Your subscription has been reactivated."
                })
            });

            /****** Delivery ******/

            // choose a custom date - picker
            flatpickr(item.querySelector(".portalSubscriptionsGridItemDeliveryModify"), {
                altFormat: "D, F j, Y",
                dateFormat: "Y-m-d",
                defaultDate: subscription.next_charge_scheduled_at,
                disableMobile: true,
                minDate: new Date().fp_incr(1)
            });

            // open date picker
            item.querySelector(".portalSubscriptionsGridItemDeliveryDate").addEventListener("click", function () {
                document.querySelector(".portalSubscriptionsGridItemDeliveryModify").click();
            });

            // choose a custom date event
            item.querySelector(".portalSubscriptionsGridItemDeliveryModify").addEventListener("change", async function () {
                // GA4 change_shipment_date
                gtag('event', 'portal_change_shipment_date');

                // start loading
                this.classList.add("loading");

                // update subscription
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, item.querySelector(".portalSubscriptionsGridItemDeliveryModify").value);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            });

            // ship now
            item.querySelector(".portalSubscriptionsGridItemDeliveryRescheduleNow").addEventListener("click", async function () {
                // GA4 ship now
                gtag('event', 'portal_ship_now');

                // start loading
                this.classList.add("loading");

                // update to today
                let newChargeDate = pushDate(new Date(), 1);
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, newChargeDate);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            })

            // push a week
            item.querySelector(".portalSubscriptionsGridItemDeliveryRescheduleWeek").addEventListener("click", async function () {
                // GA4 push week
                gtag('event', 'portal_push_week');

                // start loading
                this.classList.add("loading");

                // update to 1 week
                let newChargeDate = pushDate(new Date(subscription.next_charge_scheduled_at), 7);
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, newChargeDate);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            })

            // push a month
            item.querySelector(".portalSubscriptionsGridItemDeliveryRescheduleMonth").addEventListener("click", async function () {
                // GA4 push month
                gtag('event', 'portal_push_month');

                // start loading
                this.classList.add("loading");

                // push 30 days
                let newChargeDate = pushDate(new Date(subscription.next_charge_scheduled_at), 30);
                subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, newChargeDate);

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, false, ["date"]);
            });

            /****** Address ******/

            // open address form
            item.querySelector(".portalSubscriptionsGridItemAddressCurrentModify").addEventListener("click", function () {
                // close all forms
                closeAllForms();

                // open form
                item.querySelector(".portalSubscriptionsGridItemAddressCurrent").classList.remove("active");
                item.querySelector(".portalSubscriptionsGridItemAddressEdit").classList.add("active");

                // prefill current
                item.querySelector(".portalSubscriptionsGridItemAddressEditSelect").dispatchEvent(new Event("change"));
            });

            // change address
            item.querySelector(".portalSubscriptionsGridItemAddressEditSelect").addEventListener("change", function () {
                // if it's a new address, we empty the form, otherwise we fill it
                if (this.value === "new") {
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm").reset();
                } else {
                    // get address
                    let address = addresses.find(address => address.id === parseInt(this.value));

                    // fill form
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='first_name']").value = address.first_name;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='last_name']").value = address.last_name;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='address1']").value = address.address1;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='address2']").value = address.address2 ?? "";
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='city']").value = address.city;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='province']").value = address.province;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='zip']").value = address.zip;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='country_code']").value = address.country_code;
                    item.querySelector(".portalSubscriptionsGridItemAddressEditForm [name='phone']").value = address.phone;
                }
            });

            // update address submit
            item.querySelector(".portalSubscriptionsGridItemAddressEditForm").addEventListener("submit", async function (e) {
                e.preventDefault();

                // GA4 update address
                gtag('event', 'portal_change_address');

                // save address info
                let form = Object.fromEntries(new FormData(this));

                // validate address
                if (form.address1.toLowerCase().includes('po box') || form.address1.includes('PO')) {
                    await Swal.fire({
                        icon: "error",
                        text: "We don't ship to PO Boxes at this time."
                    });
                    return;
                }

                // check if the countries are changing
                if (form.country_code !== address.country_code) {
                    await Swal.fire({
                        icon: "error",
                        text: "You cannot change your country. Please contact support info@plantpaper.us for more information."
                    });
                    return;
                }

                // get province
                const province = form.province.toLowerCase();

                // block short codes
                if (province.length <= 2) {
                    await Swal.fire({
                        icon: "error",
                        text: ` Please enter the full state/province name.`
                    });
                    return;
                }

                // check if province is on the ban list
                for (let i = 0; i < bannedProvinces.length; i++) {
                    if (province.includes(bannedProvinces[i])) {
                        await Swal.fire({
                            icon: "error",
                            text: `We can't ship to ${bannedProvinces[i]}. Please contact support info@plantpaper.us for more information.`
                        });
                        return;
                    }
                }


                // start loading
                this.querySelector(".portalSubscriptionsGridItemAddressEditFormSave").classList.add("loading");

                // address from data
                let addressForm = Object.fromEntries(new FormData(this));

                // check if we're adding a new address
                if (item.querySelector(".portalSubscriptionsGridItemAddressEditSelect").value === "new") {
                    // assign payment method to new address
                    addressForm.payment_method_id = paymentMethod.id;

                    // create new address
                    let updatedAddress = await recharge.address.createAddress(session, addressForm);

                    // attach address to subscription
                    subscription = await recharge.subscription.updateSubscriptionAddress(session, subscription.id, updatedAddress.id);
                } else {
                    await recharge.address.updateAddress(session, address.id, addressForm);
                }

                // stop loading
                this.classList.remove("loading");

                // render subscription
                await renderSubscription(item, true, ["address"]);
            });

            // cancel update (close form)
            item.querySelectorAll(".portalSubscriptionsGridItemAddressEditFormCancel,.portalSubscriptionsGridItemAddressEditFormExit").forEach(element => element.addEventListener("click", function () {
                item.querySelector(".portalSubscriptionsGridItemAddressCurrent").classList.add("active");
                item.querySelector(".portalSubscriptionsGridItemAddressEdit").classList.remove("active");
            }));

            /****** Payment ******/

            // toggle open/close modify payment
            item.querySelector(".portalSubscriptionsGridItemPaymentCurrentModify").addEventListener("click", async function () {
                // check what processor type
                if (paymentMethod.processor_name === "stripe") {
                    // close all forms
                    closeAllForms();

                    // open stripe payment form
                    item.querySelector(".portalSubscriptionsGridItemPaymentCurrent").classList.remove("active");
                    item.querySelector(".portalSubscriptionsGridItemPaymentEdit").classList.add("active");
                } else if (paymentMethod.processor_name === "shopify_payments" && paymentMethod.payment_type === "SHOP_PAY") {
                    // show loading
                    Swal.fire({
                        title: 'Please Wait',
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    Swal.showLoading();

                    // send request
                    let formData = new FormData();
                    formData.set("paymentMethodID", paymentMethod.processor_payment_method_token);
                    let response = await fetch(`${root}/portal/update-payment-shop.php`, {
                        method: "POST",
                        body: formData
                    })
                        .then(data => data.json());

                    // check for error
                    if (response.error) {
                        await Swal.fire({
                            icon: "error",
                            title: response.error
                        });
                        return;
                    }

                    // close loading
                    Swal.close();

                    // redirect to url
                    window.location.href = response.url;
                } else if (paymentMethod.processor_name === "shopify_payments") {
                    // show loading
                    Swal.fire({
                        title: 'Please Wait',
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    Swal.showLoading();

                    // send request
                    let formData = new FormData();
                    formData.set("paymentMethodID", paymentMethod.processor_payment_method_token);
                    let response = await fetch(`${root}/portal/update-payment-shopify.php`, {
                        method: "POST",
                        body: formData
                    })
                        .then(data => data.json());

                    // check for error
                    if (response.error) {
                        await Swal.fire({
                            icon: "error",
                            title: response.error
                        });
                        return;
                    }

                    await Swal.fire({
                        title: "For security reasons, please check your email to update your payment method."
                    });
                } else {
                    await Swal.fire({
                        "icon": "error",
                        "title": "Please contact support with error P2."
                    });
                }
            });

            // update payment
            item.querySelector(".portalSubscriptionsGridItemPaymentEditForm").addEventListener("submit", async function (e) {
                e.preventDefault();

                // start loading
                this.querySelector(".portalSubscriptionsGridItemPaymentEditFormSave").classList.add("loading");

                // send request
                let formData = new FormData(this);
                formData.set("recharge_customer_id", session.customerId)
                formData.set("stripe_customer_id", paymentMethod.processor_customer_token);
                formData.set("recharge_address_id", address.id);
                let response = await fetch(`${root}/portal/update-payment-stripe.php`, {
                    method: "POST",
                    body: formData
                })
                    .then(data => data.json());

                // stop loading
                this.querySelector(".portalSubscriptionsGridItemPaymentEditFormSave").classList.remove("loading");

                // check for error
                if (response.error) {
                    await Swal.fire({
                        icon: "error",
                        title: response.error
                    });
                    return;
                }

                // render subscription
                await renderSubscription(item, true, ["payment"]);
            });

            // cancel update
            item.querySelectorAll(".portalSubscriptionsGridItemPaymentEditFormCancel,.portalSubscriptionsGridItemPaymentEditFormExit").forEach(element => element.addEventListener("click", function () {
                // close the form
                item.querySelector(".portalSubscriptionsGridItemPaymentCurrent").classList.add("active");
                item.querySelector(".portalSubscriptionsGridItemPaymentEdit").classList.remove("active");

                // reset form
                item.querySelector(".portalSubscriptionsGridItemPaymentEditForm").reset();
            }));
        }

        // initial render
        renderSubscription(null, false, []);
    });

    /************** Tissue Upsell *****************/

    // update pricing based on country
    if (countryExperience === "US") {
        // upgrade to 16/32 pack pricing
        document.querySelector("#tissue164Price").textContent = "+" + price((products[handleToVariantID["16-rolls-4-boxes"]].subscription_price - products[handleToVariantID["16-rolls"]].subscription_price));
        document.querySelector("#tissue328Price").textContent = "+" + price((products[handleToVariantID["32-rolls-8-boxes"]].subscription_price - products[handleToVariantID["32-rolls"]].subscription_price));
        document.querySelector("#tissue12Price").textContent = "+" + price(products[handleToVariantID["12-boxes"]].subscription_price);
    } else {
        document.querySelector("#tissue164Price").textContent = "+" + price((products[handleToVariantID["16-rolls-4-boxes-ca"]].subscription_price - products[handleToVariantID["16-rolls-ca"]].subscription_price));
        document.querySelector("#tissue328Price").textContent = "+" + price((products[handleToVariantID["32-rolls-8-boxes-ca"]].subscription_price - products[handleToVariantID["32-rolls-ca"]].subscription_price));
        document.querySelector("#tissue12Price").textContent = "+" + price(products[handleToVariantID["12-boxes-ca"]].subscription_price);
    }

    // function to setup tissues if eligible
    function setupEligibleTissueOffers() {
        // bring us back to the initial state as data may have changed
        document.querySelector('#portalSubscriptionsTissuesOptions').classList.remove("active");
        document.querySelectorAll(".portalSubscriptionsTissuesOptionsLabelInput").forEach(element => element.checked = false);
        document.querySelector('#portalSubscriptionsTissuesAddress').classList.remove("active");
        document.querySelector("#portalSubscriptionsTissuesButton").textContent = "Order Facial Tissue";

        // determine if the person is eligible for tissues
        let eligible = false;

        // Must have an active subscription that is any rolls variant
        subscriptions.forEach(subscription => {
            let variantID = parseInt(subscription.external_variant_id.ecommerce);
            if (subscription.status === "active" && (rollsVariantsUS.includes(variantID) || rollsVariantsCA.includes(variantID))) {
                eligible = true;
            }
        });

        // Must not have any ACTIVE subscription that are bundles or tissues
        subscriptions.forEach(subscription => {
            let variantID = parseInt(subscription.external_variant_id.ecommerce);
            if (
                subscription.status === "active" &&
                (
                    bundlesVariantsUS.includes(variantID) ||
                    bundlesVariantsCA.includes(variantID) ||
                    variantID === tissueVariantUS ||
                    variantID === tissueVariantCA
                )
            ) {
                eligible = false;
            }
        });

        // exit if not eligible
        if (!eligible) {
            document.querySelector("#portalSubscriptionsTissuesWrapper").classList.remove("active");
            return;
        }

        // check for popup mode
        if (sessionStorage.getItem("tissue_popup")) {
            document.querySelector("#portalSubscriptionsTissuesWrapper").classList.add("popup");
            sessionStorage.removeItem("tissue_popup");
        }

        // show upsell
        document.querySelector("#portalSubscriptionsTissuesWrapper").classList.add("active");

        // hide both 16 and 32 pack title and options
        document.querySelector(".portalSubscriptionsTissuesOptionsTitle[data-eligible='16,32']").classList.remove("active");
        document.querySelector(`.portalSubscriptionsTissuesOptionsLabel[data-eligible="16"]`).classList.remove("active");
        document.querySelector(`.portalSubscriptionsTissuesOptionsLabel[data-eligible="32"]`).classList.remove("active");

        // determine how many active 16 and 32 pack subscriptions they have
        let active16Packs = [];
        let active32Packs = [];
        if (countryExperience === "US") {
            active16Packs = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsUS[0]);
            active32Packs = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsUS[1]);
        } else {
            active16Packs = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsCA[0]);
            active32Packs = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsCA[1]);
        }

        // if they have any active subscriptions
        if (active16Packs.length > 0 || active32Packs.length > 0) {
            // show title
            document.querySelector(".portalSubscriptionsTissuesOptionsTitle[data-eligible='16,32']").classList.add("active");

            // show 16 + 4 if they have 16 packs
            if (active16Packs.length > 0) {
                document.querySelector(`.portalSubscriptionsTissuesOptionsLabel[data-eligible="16"]`).classList.add("active");
            }

            // show 32 + 8 if they have 32 packs
            if (active32Packs.length > 0) {
                document.querySelector(`.portalSubscriptionsTissuesOptionsLabel[data-eligible="32"]`).classList.add("active");
            }
        }

    }

    // initial setup
    setupEligibleTissueOffers();

    // start button click
    document.querySelector("#portalSubscriptionsTissuesButton").addEventListener("click", async function () {
        // PHASE 1 - start
        if (this.textContent === "Order Facial Tissue") {
            // update atc text
            this.textContent = `Add tissues to my subscription`;

            // show options container
            document.querySelector("#portalSubscriptionsTissuesOptions").classList.add("active");
        }

        // PHASE 2 - get address
        else if (this.textContent === "Add tissues to my subscription") {
            // check if no an option is selected
            if (document.querySelector(".portalSubscriptionsTissuesOptionsLabelInput:checked") === null) {
                await Swal.fire({
                    text: "Please select a tissue offer to continue."
                });
                return;
            }

            // hide options container
            document.querySelector("#portalSubscriptionsTissuesOptions").classList.remove("active");

            // show address container
            document.querySelector("#portalSubscriptionsTissuesAddress").classList.add("active");

            // get active option
            let upsell = document.querySelector(".portalSubscriptionsTissuesOptionsLabelInput:checked").value;

            // eligible subscriptions represents the subscriptions that are eligible for the upsell
            let eligibleSubscriptions;

            if (countryExperience === "US") {
                // get list of eligible 16 packs
                if (upsell === "16+4") {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsUS[0]);
                }
                // get list of eligible 32 packs
                else if (upsell === "32+8") {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsUS[1]);
                }
                // tissues we show all active subscriptions
                else {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active");
                }
            } else {
                // get list of eligible 16 packs
                if (upsell === "16+4") {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsCA[0]);
                }
                // get list of eligible 32 packs
                else if (upsell === "32+8") {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active" && parseInt(subscription.external_variant_id.ecommerce) === rollsVariantsCA[1]);
                }
                // tissues we show all active subscriptions
                else {
                    eligibleSubscriptions = subscriptions.filter(subscription => subscription.status === "active");
                }
            }

            // generate a list of addresses without duplicates
            let eligibleAddresses = [];
            eligibleSubscriptions.forEach(subscription => {
                if (!eligibleAddresses.includes(subscription.address_id)) {
                    eligibleAddresses.push(subscription.address_id);
                }
            });

            // add address for next step that are eligible
            let HTML = "";
            addresses.forEach(address => {
                if (eligibleAddresses.includes(address.id)) {
                    HTML += `<option value="${address.id}">${address.address1}</option>`;
                }
            });

            // create options
            document.querySelector("#portalSubscriptionsTissuesAddressSelect").innerHTML = HTML;

            // update atc text
            this.textContent = `Confirm address`;

            // AUTO CONFIRM ADDRESS IF ONLY ONE
            if (eligibleAddresses.length === 1) {
                this.click();
            }
        }

        // PHASE 3 - confirm payment
        else if (this.textContent === "Confirm address") {
            // hide address container
            document.querySelector("#portalSubscriptionsTissuesAddress").classList.remove("active");

            // start loading
            this.classList.add("loading");

            // get active option
            let upsell = document.querySelector(".portalSubscriptionsTissuesOptionsLabelInput:checked").value;

            // get the selected address
            let address = addresses.find(address => address.id === parseInt(document.querySelector("#portalSubscriptionsTissuesAddressSelect").value));

            // find the first subscription with this address that's active
            let subscription = subscriptions.find(subscription => subscription.status === "active" && subscription.address_id === address.id);

            // if they're upgrading to the 16+4 or 32+8, we need to update they're existing subscription
            if (upsell === "16+4" || upsell === "32+8") {
                let updatedSubscription;
                if (countryExperience === "US") {
                    updatedSubscription = await recharge.subscription.updateSubscription(session, subscription.id, {
                        external_variant_id: {
                            ecommerce: (upsell === "16+4") ? `${bundlesVariantsUS[0]}` : `${bundlesVariantsUS[1]}`
                        }
                    });
                } else {
                    updatedSubscription = await recharge.subscription.updateSubscription(session, subscription.id, {
                        external_variant_id: {
                            ecommerce: (upsell === "16+4") ? `${bundlesVariantsCA[0]}` : `${bundlesVariantsCA[1]}`
                        }
                    });
                }

                // refresh subscription pricing
                await refreshSubscriptionPrice(updatedSubscription.id);
            }
            // otherwise we need to create a new subscription for the tissues
            else {
                // get interval
                let interval = parseInt(document.querySelector(".portalSubscriptionsTissuesOptionsLabelFrequency").value);

                // create new subscription
                let newSubscription;
                if (countryExperience === "US") {
                    newSubscription = await recharge.subscription.createSubscription(session, {
                        address_id: address.id,
                        next_charge_scheduled_at: subscriptions.find(subscription => subscription.status === "active").next_charge_scheduled_at,
                        charge_interval_frequency: interval,
                        order_interval_frequency: interval,
                        order_interval_unit: 'week',
                        quantity: 1,
                        external_variant_id: {
                            ecommerce: `${tissueVariantUS}`,
                        },
                        external_product_id: {
                            ecommerce: `${products[tissueVariantUS].id}`,
                        }
                    });
                } else {
                    newSubscription = await recharge.subscription.createSubscription(session, {
                        address_id: address.id,
                        next_charge_scheduled_at: subscriptions.find(subscription => subscription.status === "active").next_charge_scheduled_at,
                        charge_interval_frequency: interval,
                        order_interval_frequency: interval,
                        order_interval_unit: 'week',
                        quantity: 1,
                        external_variant_id: {
                            ecommerce: `${tissueVariantCA}`,
                        },
                        external_product_id: {
                            ecommerce: `${products[tissueVariantCA].id}`,
                        }
                    });
                }

                // refresh subscription pricing
                await refreshSubscriptionPrice(newSubscription.id);
            }

            // stop loading
            this.classList.remove("loading");

            // success
            await Swal.fire({
                icon: "success",
                title: "Tissues have been added successfully.",
            });

            // refresh
            Swal.fire({
                title: 'Refreshing',
                allowOutsideClick: () => !Swal.isLoading()
            });
            Swal.showLoading();
            window.location.reload();
        }

    });

    // close on wrapper click
    document.querySelector("#portalSubscriptionsTissuesWrapper").addEventListener("click", function (e) {
        if (e.target === this) {
            this.classList.remove("popup");
        }
    });

    /********************* Referral *********************/

    // exit referrals
    document.querySelector("#portalReferralsExit").addEventListener("click", function (e) {
        document.querySelector("#portalSubscriptions").classList.add("active");
        document.querySelector("#portalReferrals").classList.remove("active");
    });

    // submit new referral
    document.querySelector("#portalReferralsNewForm").addEventListener("submit", async function (e) {
        e.preventDefault();

        // get form data
        const formData = new FormData(this);

        // add other required information
        formData.set("from_name", `${customer.first_name} ${customer.last_name}`);
        formData.set("from_email", customer.email);

        // start loading on button
        document.querySelector('#portalReferralsNewFormButton').classList.add('loading');

        // send form data
        const response = await fetch(`${root}/referrals/portal/new.php`, {
            method: 'POST',
            body: JSON.stringify(Object.fromEntries(formData)),
        })
            .then(response => response.json());

        // stop loading on button
        document.querySelector('#portalReferralsNewFormButton').classList.remove('loading');

        // check for error
        if (response.error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: response.error,
            })
            return;
        }

        // reset form
        this.reset();

        // show success message
        Swal.fire({
            icon: 'success',
            title: 'Success',
            text: `Your referral has been sent to ${formData.get('to_email')} successfully!`,
        });

        await setupReferralHistory();
    })

    // setup referal histroy
    async function setupReferralHistory() {
        // get referral history
        const referrals = await fetch(`${root}/referrals/portal/get-history.php`, {
            method: "POST",
            body: JSON.stringify({
                email: customer.email,
                customer_id: parseInt(customer.external_customer_id.ecommerce)
            })
        })
            .then(response => response.json());

        // if there is an error, exit
        if (referrals.error) {
            return;
        }

        // generate html
        let sentHTML = "";
        let redeemedHTML = "";
        referrals.forEach(document => {
            // check if the referral hasn't been used yet
            if (document.to.discount_code_used === false) {
                sentHTML += `
                    <span>${document.to.name}</span>
                    <span>${mongoDateToHuman(document.created_at)}</span>                
                `;
            }
            // check if the referral hasn't been applied yet
            else if (document.from.applied_at.length === 0) {
                redeemedHTML += `
                    <span>${document.to.name}</span>
                    <span>$${document.from.available_credit_dollars} applied to next renewal</span>                
                `;
            }
            // otherwise the discount has been applied
            else {
                // create a list of dates html since there can be more than 1
                let datesHTML = "";
                document.from.applied_at.forEach(date => {
                    datesHTML += mongoDateToHuman(date);
                    datesHTML += `<br>`;
                });

                // add response
                redeemedHTML += `
                    <span>${document.to.name}</span>
                    <span>${datesHTML}</span>        
                `;
            }
        })

        // update html
        document.querySelector("#portalReferralsHistorySent").innerHTML = sentHTML;
        document.querySelector("#portalReferralsHistoryRedeemed").innerHTML = redeemedHTML;
    }

    // load initial referral history
    setupReferralHistory();

    /********* General Account Functions **********/

    // open referrals
    document.querySelectorAll(`#portalAccountReferrals, a[href="#referrals"]`).forEach(function (element) {
        element.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector("#portalSubscriptions").classList.remove("active");
            document.querySelector("#portalReferrals").classList.add("active");

            // on mobile, scroll to referrals
            if (window.innerWidth <= 800) {
                document.querySelector("#portalReferrals").scrollIntoView();
            }
        });

        // auto click on referrals if we have a paramter
        if (urlParams.has("open_referrals")) {
            element.click();
        }
    });

    // see past orders
    document.querySelector("#portalAccountPastOrders").addEventListener("click", async function () {
        // GA4 view past orders
        gtag('event', 'portal_view_past_orders');

        // return date and time
        function getDateTime(date) {
            let dateObj = new Date(parseInt(date["$date"]["$numberLong"]));
            return `${dateObj.toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                }
            )}`;
        }

        // send request
        let formData = new FormData();
        formData.set("email", customer.email);
        formData.set("customerID", customer.external_customer_id.ecommerce);
        let response = await fetch(`${root}/portal/get-orders.php`, {
            method: "POST",
            body: formData
        })
            .then(response => response.json());

        // check for error
        if (response.error) {
            await Swal.fire({
                icon: "error",
                title: response.error
            });
            return;
        }

        // generate HTML
        let HTML = `
            <table border="1" style="border-collapse: collapse; width: 100%;">
                <tr>
                    <td><b>Order #</b></td>
                    <td><b>Order Date</b></td>
                    <td><b>Total Price</b></td>
                </tr>
        `;
        response.forEach(order => {
            HTML += `
                <tr>
                    <td><a href="${order.order_status_url}" target="_blank" style="text-decoration: underline">#${order.name}</a></td>
                    <td>${getDateTime(order.created_at)}</td>
                    <td>$${order.total_price}</td>
                </tr>
            `;
        })
        HTML += "</table>"

        // show popup
        await Swal.fire({
            "title": "Past Orders",
            "html": HTML,
            "customClass": {
                popup: "malterWide"
            }
        })

    });

    // show inactive subscriptions
    document.querySelector("#portalAccountInactiveSubscriptions").addEventListener("click", async function () {
        // check if we have any cancelled subscriptions
        if (subscriptions.filter(subscription => subscription.status === "cancelled").length === 0) {
            await Swal.fire({
                title: "You do not have any inactive subscriptions to cancel."
            });
            return;
        }

        // show label
        document.querySelector("#portalSubscriptionsGridCancelled").classList.toggle("active");

        // show all hidden subscriptions
        document.querySelectorAll(`.portalSubscriptionsGridItem[data-status="cancelled"]`).forEach(item => item.classList.toggle("active"));

        // smooth scroll
        document.querySelector("#portalSubscriptionsGridCancelled").scrollIntoView();

        // update label
        if (document.querySelector("#portalSubscriptionsGridCancelled").classList.contains("active")) {
            this.textContent = "Hide inactive subscriptions";
        } else {
            this.textContent = "Show inactive subscriptions";
        }
    });

    // show inactive subscriptions if there are no active subscriptions
    if (subscriptions.filter(subscription => subscription.status === "active").length === 0) {
        document.querySelector("#portalAccountInactiveSubscriptions").click();
    }

    // logout
    document.querySelector("#portalAccountLogout").addEventListener("click", logout);

    /********* Cancel Subscription **********/

    dialogPolyfill.registerDialog(document.querySelector("#cancel"));
    document.querySelector("#portalAccountCancel").addEventListener("click", async function () {
        // vwo event
        window.VWO = window.VWO || [];
        VWO.event = VWO.event || function () {
            VWO.push(["event"].concat([].slice.call(arguments)))
        };
        VWO.event("portalCancellationStarted");

        // GA4 cancel subscription
        gtag('event', 'portal_cancel_subscription');

        // hide all previous screens
        document.querySelectorAll('#cancel div').forEach(item => {
            item.classList.remove('active');
        })

        // show the title and reset
        document.querySelector('#cancelTitle').style.display = "block";
        document.querySelector('#cancelTitle').innerHTML = "Which subscription would you like to cancel?"

        // check if we have any active subscriptions
        if (subscriptions.filter(subscription => subscription.status === "active").length === 0) {
            await Swal.fire({
                title: "You do not have any active subscriptions to cancel."
            });
            return;
        }

        // show subscriptions
        document.querySelector('#cancelSubscriptionsWrap').classList.add("active");

        // reset container
        document.querySelector("#cancelSubscriptions").innerHTML = "";

        // append new subscription options
        subscriptions.forEach(subscription => {
            // only show active subscriptions
            if (subscription.status !== "active") {
                return;
            }

            // find address
            let address = addresses.find(address => address.id === subscription.address_id);

            // append
            document.querySelector("#cancelSubscriptions").insertAdjacentHTML("beforeend", `
                <label class="cancelSubscriptionsItem">
                    <input class="cancelSubscriptionsItemCheckbox" name="cancel_subscription" type="radio" value="${subscription.id}">
                    <div class="cancelSubscriptionsItemProduct">${subscription.product_title}</div>
                    <div class="cancelSubscriptionsItemAddress">
                        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path id="795_home 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M5.2511 5.31248L0.0128082 10.625L0.00642321 10.9783L0 11.3317L1.30147 11.3316H2.60298L2.61267 14.656L2.6224 17.9803H5.90989H9.19739L9.20724 15.9852L9.21708 13.99L10.4994 14.0002L11.7818 14.0104L11.7896 15.9953L11.7974 17.9803L15.0866 17.9902L18.3758 18V14.6649V11.3297L19.6775 11.3327L20.9792 11.3357L20.9896 10.9964L21 10.6571L19.0228 8.65302L17.0456 6.64889V3.64753V0.646176L16.9601 0.669418C16.9131 0.682176 16.3145 0.69289 15.6299 0.69316L14.3852 0.6937V2.32199V3.95033L12.4373 1.97514L10.4894 0L5.2511 5.31248Z" fill="#FF9417"></path> </svg>
                        ${address.address1}
                    </div>
                </label>
            `)
        });

        // open popup
        document.querySelector("#cancel").showModal();
    });


    // cancel subscription
    document.querySelector("#cancelConfirm").addEventListener("click", async function () {
        // get selected element
        let selected = document.querySelector(".cancelSubscriptionsItemCheckbox:checked");

        // check if one is selected
        if (!selected) {
            await Swal.fire({
                title: "Please select a subscription to cancel.",
                target: "#cancel"
            });
            return;
        }

        // save the selected item
        sessionStorage.setItem("currentSub", selected.value);

        // start flow
        document.querySelector('#cancelTitle').innerHTML = "Why do you want to cancel?"

        // present reasons why to cancel
        let reasons = document.querySelector('#cancelReasons');
        reasons.classList.add('active');

        // hide the displayed list of subscriptions
        document.querySelector("#cancelSubscriptionsWrap").classList.remove("active");
    });

    // proceeds to the resolution screen if option selected
    document.querySelector('#cancelReasonsButton').addEventListener('click', async function () {
        // collect reason for cancellation
        let selectedReason = document.querySelector('#cancelReasons input:checked');

        // if no reason is selected, show an error
        if (!selectedReason) {
            await Swal.fire({
                title: "Please choose a reason why you're cancelling.",
                target: "#cancel"
            });
            return;
        }

        // get resolution screen
        let resolution = document.querySelector('#cancelResolution');

        // reset resolution screen
        resolution.innerHTML = "";

        // hide the title
        document.querySelector('#cancelTitle').style.display = "none";

        // show the resolution screen and hide the previous screen
        resolution.classList.add('active');
        resolution.classList.contains('active') ? document.querySelector("#cancelReasons").classList.remove("active") : null;

        // create current subscription variable
        let currentSubscription;

        // look through all active subscriptions and find the correct one
        subscriptions.forEach(subscription => {
            if (subscription.status === "active") {
                // check if subscription id is the id we need, and if it is, grab and save it
                if ((subscription.id).toString() === (sessionStorage.getItem("currentSub")).toString()) {
                    currentSubscription = subscription;
                }
            }
        })

        // get the parent
        let parent = document.querySelector('#cancelResolution');

        // options for improvement when the user selects Performance
        const improveOptions = [
            {
                reason: "It wasn’t soft enough",
                value: "Softness"
            },
            {
                reason: "I didn’t like the color",
                value: "Color"
            },
            {
                reason: "I didn’t like the packaging",
                value: "Packaging"

            },
            {
                reason: "I’m sticking with my UTIs",
                value: "UTIs"

            },
            {
                reason: "I prefer TP packed with chemicals",
                value: "Chemicals"
            },
            {
                reason: "I love the TP but the rolls are too small",
                value: "Size"
            }
        ]

        // generate the options a user can choose for why they are cancelling using improveOptions
        function populateOptions(options) {
            let html = "";

            // loop through the given options and use them to generate HTML
            options.forEach(option => {
                html += `
                <div class="cancelResolutionImproveOption" data-value="${option.value}"
                    data-reason="${option.reason}">
                    <span class="cancelResolutionImproveOptionCheckbox">
                    </span>
                    <div class="cancelResolutionImproveOptionTitle">
                        ${option.reason}
                    </div>
                </div>`
            })
            // return the generated HTML
            return html;
        }

        // function used to give user options to modify their subscription
        function updateAddress(sub) {
            // get current address
            let address = addresses.filter(address => address.id === sub.address_id)[0];

            //setup values
            let firstName, lastName, addressOne, addressTwo, city, zip, phone;

            // get values
            if (address) {
                firstName = address.first_name ? address.first_name : "";
                lastName = address.last_name ? address.last_name : "";
                addressOne = address.address1 ? address.address1 : "";
                addressTwo = address.address2 ? address.address2 : "";
                city = address.city ? address.city : "";
                zip = address.zip ? address.zip : "";
                phone = address.phone ? address.phone : "";
            }

            return `<div class="cancelResolutionAddress active">
                            <div class="cancelResolutionAddressEdit">
                                <div class="cancelResolutionAddressEditLabel">Modify address:</div>
                                <form class="cancelResolutionAddressEditForm">
                                <div class="cancelResolutionAddressEditFormWrap">
                                    <input type="text" name="first_name" placeholder="First Name" aria-label="First Name" required value="${firstName}">
                                    <input type="text" name="last_name" placeholder="Last Name" aria-label="Last Name" required
                                    value="${lastName}">
                                    <input type="text" name="address1" placeholder="Address Line 1" aria-label="Address Line 1" required
                                    value="${addressOne}">
                                    <input type="text" name="address2" placeholder="Address Line 2" aria-label="Address Line 2"
                                    value="${addressTwo}">
                                    <input type="text" name="city" placeholder="City" aria-label="City" required
                                    value="${city}">
                                    <input type="text" name="zip" placeholder="ZIP code" aria-label="ZIP code" required
                                    value="${zip}">
                               
                                    <input type="tel" name="phone" placeholder="Phone number" aria-label="Phone number" required
                                    value="${phone}">
                                    </div>
                                    <button class="cancelResolutionAddressEditFormSave portalButton primary">Update my address</button>
                                </form>
                            </div>
                        </div>
`
        }

        // function to determine how much a user can save by switching to bulk

        function saveBulk(sub) {
            // variable to determine if eligible for calculations
            let packSize = "";

            let variantSub = parseInt(sub.external_variant_id.ecommerce);

            // declare pricing variable
            let pricing;

            // declare pricing for 96 pack
            let bulkPrice;

            // declare price per roll variable
            let currentPricePerRoll;


            // first check if the current subscription is a 32 or 16 pack what region it is
            // if USA 16 pack
            if (rollsVariantsUS[0] === variantSub) {
                pricing = parseFloat(products[rollsVariantsUS[0]].subscription_price);
                bulkPrice = parseFloat(products[rollsVariantsUS[2]].subscription_price);
                currentPricePerRoll = (pricing / 16).toFixed(2);
            }
            // if USA 32 pack
            else if (rollsVariantsUS[1] === variantSub) {
                pricing = parseFloat(products[rollsVariantsUS[1]].subscription_price);
                bulkPrice = parseFloat(products[rollsVariantsUS[2]].subscription_price);
                currentPricePerRoll = (pricing / 32).toFixed(2);
            }
            // if CA 16 pack
            else if (rollsVariantsCA[0] === variantSub) {
                pricing = parseFloat(products[rollsVariantsCA[0]].subscription_price);
                bulkPrice = parseFloat(products[rollsVariantsCA[2]].subscription_price);
                currentPricePerRoll = (pricing / 16).toFixed(2);
            }
            // if CA 32 pack
            else if (rollsVariantsCA[1] === variantSub) {
                pricing = parseFloat(products[rollsVariantsCA[1]].subscription_price);
                bulkPrice = parseFloat(products[rollsVariantsCA[2]].subscription_price);
                currentPricePerRoll = (pricing / 32).toFixed(2);
            } else {
                return;
            }

            // determine how much it costs per roll for the current subscription compared to 96 pack
            let savingsPerRoll = ((currentPricePerRoll - (bulkPrice / 96)).toFixed(2));
            // determine the savings percentage when switching to bulk
            let savings = (savingsPerRoll / currentPricePerRoll * 100).toFixed(0) + "%";

            return savings;
        }

        /****************** Resolution Templates **************/

            // since the excessive and insufficient reasons are the same, we can create a shared template for them
        let template = `  
            <div id="cancelResolutionTitle">
                Did you know you can easily 
                <strong>adjust your frequency?</strong>
            </div>
            <div class="cancelResolutionWrap active">
            <span class="cancelResolutionMini">
                Modify your subscription:
            </span>
            <div class="cancelResolutionOptions">
                <select class="cancelResolutionModify">
                ${planHTML()}
                </select>
                <select class="cancelResolutionFrequency">
                ${cadenceHTML()}</select>
            </div>
            </div>
            <button class="cancelResolutionUpdate portalButton primary">
                Update my subscription
            </button>
            <button id="cancelResolutionProceed" title="Proceed with cancellation">
                Thanks, but I still need to cancel.
            </button>
            `

        // the templates we create and show to the user based on their cancellation reason
        const cancelTemplates = {
            Excess: template,
            Insufficient: template,
            Expensive: `
                <div id="cancelResolutionTitle">
                    Here’s a few ways you can pay less for PlantPaper:
                </div>
                <div id="cancelResolutionSubtitle">
                    Switch to our bulk size.
                </div>
                <span class="cancelResolutionSave">
                    You’ll save up to: <u>${saveBulk(currentSubscription)}</u>
                </span>
                <button id="cancelResolutionBulk" 
                    title="Switch to bulk and save"
                    class="portalButton primary">
                    Switch to bulk and save
                </button>   
                <button id="cancelResolutionProceed" 
                    title="Proceed with cancellation">
                    Thanks for the recommendation, but I still need to cancel.
                </button>`,
            Performance: `
                <div id="cancelResolutionTitle">
                    How could we improve?
                    <br>
                    (click up to 3)
                </div>
                <div id="cancelResolutionImprove" class="active">
                    ${populateOptions(improveOptions)}
                </div>
                <button class="cancelResolutionImproveCancel portalButton primary" 
                    title="Next">
                    Next
                </button>
                `,
            Moving: `
                <div id="cancelResolutionTitle">
                    Did you know you can easily 
                    <strong>adjust your address?</strong> 
                </div>
                <br>
                ${updateAddress(currentSubscription)}
              <button class="cancelResolutionRelocationPauseNext portalButton primary">Adjust delivery date</button>
                <button class="cancelResolutionRelocationPause portalButton primary"></button>
                <button id="cancelResolutionProceed" 
                title="Proceed with cancellation">
                Thanks, but I still need to cancel.
                </button>`,
            Relocating: `
                <div id="cancelResolutionTitle">
                    <strong>Going out of town for a while?</strong>
                    You can skip your next shipment(s) as needed.
                </div>
                <div class="cancelResolutionRelocation">
                    <button class="cancelResolutionRelocationSkip portalButton primary" data-value="1">Skip my next shipment</button>
                    <button class="cancelResolutionRelocationSkip portalButton primary" data-value="2">Skip my next 2 shipments</button>
                    <button class="cancelResolutionRelocationSkip portalButton primary" data-value="3">Skip my next 3 shipments</button>
                    <button id="cancelResolutionProceed" 
                    title="Proceed with cancellation">
                    Thanks, but I still need to cancel.
                    </button>
                </div>`,
            Payment:
                `
                <div id="cancelResolutionTitle">
                <strong>You can adjust your payment method here:</strong>
                <br>
                <br>
                    You can also skip your next shipment, or control your orders by text.
                </div>
                <button class="cancelResolutionPayment portalButton primary">
                    Update Payment Method
                </button>
                <button id="cancelResolutionProceed" 
                    title="Proceed with cancellation">
                    Thanks, but I still need to cancel.
                </button>`,
            Duplicate: `
                <div id="cancelResolutionTitle" class="center">
                <b>Got it.</b>
                <br>
                <br>
                Please <button class="cancelSub" style="max-width: fit-content; display: inline-block">
                <u>click here</u>
                </button>
                to complete your cancellation.
                </div>`,
            Deliveries: `
            <div id="cancelResolutionTitle">
            Maybe we can help. 
            <br>
            <br>
            <a class="cancelResolutionEmail" href="mailto:info@plantpaper.us"><u>Click here</u></a> to send an email to our customer service team, who can set you up to manage your subscription by text and/or adjust your frequency and pack size to better meet your needs.
               <button id="cancelResolutionProceed" 
                    title="Proceed with cancellation">
                    Thanks, but I still need to cancel.
                    </button>
            </div>`
        }

        // Excess or insufficient items
        function planHTML() {

            // find product in our matrix
            let product = products[currentSubscription.external_variant_id.ecommerce];

            // parse their price
            let currentSubscriptionPrice = parseFloat(currentSubscription.price) * 100;

            // function to generate option HTML based on the variant
            function optionHTML(variantID) {
                // default price
                let retailPrice = price(products[variantID].subscription_price);

                // check if this option is the current subscription
                let isActiveProduct = variantID === product.variant_id;

                // check if this option is their current product and check if their price is lower than retail
                if (isActiveProduct && currentSubscriptionPrice < product.subscription_price) {
                    retailPrice = `Legacy - ${price(currentSubscriptionPrice)}`
                }

                // return HTML
                return `
                        <option class="cancelModifyOption" value="${variantID}" ${isActiveProduct ? "selected" : ""}>
                            ${products[variantID].modify_title} (${retailPrice})
                        </option>
                    `;
            }

            // html string
            let HTML = "";

            // check for USA plan
            if (rollsVariantsUS.includes(product.variant_id) || bundlesVariantsUS.includes(product.variant_id)) {
                // add base plans and select their current variant
                rollsVariantsUS.forEach(variantID => {
                    HTML += optionHTML(variantID);
                });

                // add add-ons and select their current variant
                HTML += `<optgroup label="Tissue bundles:">`;
                bundlesVariantsUS.forEach(variantID => {
                    HTML += optionHTML(variantID);
                });
                HTML += `</optgroup>`;
            }
            // check for CA plan
            else if (rollsVariantsCA.includes(product.variant_id) || bundlesVariantsCA.includes(product.variant_id)) {
                rollsVariantsCA.forEach(variantID => {
                    HTML += optionHTML(variantID);
                });

                // add add-ons and select their current variant
                HTML += `<optgroup label="Tissue bundles:">`;
                bundlesVariantsCA.forEach(variantID => {
                    HTML += optionHTML(variantID);
                });
                HTML += `</optgroup>`;
            }
            // return their current variant
            else {
                HTML += `<option value="${product.variant_id}">${product.modify_title} (${price(currentSubscriptionPrice)})</option>`;
            }

            return HTML;
        }

        // function for cadence html
        function cadenceHTML() {
            let HTML = "";

            // cadence options updated for cancellation
            // 3 - 24
            const cadences = [...Array(22).keys()].map(i => i + 3);

            // check if we have a custom cadence
            if (!cadences.includes(currentSubscription.order_interval_frequency)) {
                HTML += `<option value="${currentSubscription.order_interval_frequency}" selected>Every ${currentSubscription.order_interval_frequency} ${currentSubscription.order_interval_unit}</option>`;
            }

            // generate HTML
            // use cadences from 3 to 24 weeks
            cadences.forEach(cadence => {
                HTML += `<option value="${cadence}" ${cadence === currentSubscription.order_interval_frequency ? "selected" : ""}>Every ${cadence} weeks</option>`;
            })

            return HTML;
        }

        // function to rate plantPaper
        function ratePlantPaper() {
            return `
                <div id="cancelResolutionTitle" class="center" style="margin-bottom: 15px">
                    <strong>Cost aside, did you enjoy using PlantPaper?</strong>
                </div>
                  <div id="cancelResolutionSubtitle" class="center" 
                  style="font-weight: 500; margin-bottom: 30px">
                    (10 = I loved it. 1 = I hated it.)
                </div>
                <div class="cancelResolutionRating">
                    <div class="cancelResolutionRatingOption" data-value="1">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        1
                    </div>
                    <div class="cancelResolutionRatingOption" data-value="2">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        2
                    </div>
                    <div class="cancelResolutionRatingOption" data-value="3">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        3
                    </div>
                    <div class="cancelResolutionRatingOption" data-value="4">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        4
                    </div>
                    <div class="cancelResolutionRatingOption" data-value="5">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        5
                    </div> <div class="cancelResolutionRatingOption" data-value="6">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        6
                    </div>
                    <div class="cancelResolutionRatingOption" data-value="7">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        7
                    </div>
                    <div class="cancelResolutionRatingOption" data-value="8">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        8
                    </div>
                    <div class="cancelResolutionRatingOption" data-value="9">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        9
                    </div>
                    <div class="cancelResolutionRatingOption" data-value="10">
                        <span class="cancelResolutionRatingOptionCircle"></span>
                        10
                    </div>
                </div>
                <button class="cancelResolutionRatingCancel">
                Continue to cancel my subscription
                </button>
            `;
        }

        // use event delegation to handle clicks on the rating options
        document.querySelector('#cancelResolution').addEventListener('click', function (e) {
            // check if the clicked element is a rating option
            if (e.target.classList.contains('cancelResolutionRatingOption')) {
                // remove active class from all options
                document.querySelectorAll('.cancelResolutionRatingOption').forEach(item => {
                    item.classList.remove('active');
                });

                // add active class to the clicked option
                e.target.classList.add('active');
            }

            if (e.target.classList.contains('cancelResolutionRatingCancel')) {
                // get the selected rating value
                let ratingValue = document.querySelector('.cancelResolutionRatingOption.active')?.getAttribute('data-value');

                // check if a rating was selected
                if (!ratingValue) {
                    Swal.fire({
                        icon: "error",
                        title: "Please select a rating before proceeding.",
                        target: "#cancel"
                    });
                    return;
                }

                cancelOnClose();
            }
        })

        // function for cancelling subscription on modal close
        // Used by multiple templates
        async function cancelOnClose() {
            document.querySelector('#cancelResolution').innerHTML = `<div id="cancelResolutionTitle" class="center">
                <strong>We’re sorry to see you go.</strong>
                <br>
                    <br>
                        Your subscription account will remain ‘inactive’. If you decide to come back you can return to your portal and simply click ‘re-activate’.
            </div>`

            // determine the cancellation reason
            let cancelReason;
            switch (selectedReason.value) {
                case 'Deliveries':
                    cancelReason = "Trouble managing deliveries."
                    break;
                case 'Excess':
                    cancelReason = "I have more than I need."
                    break;
                case 'Insufficient':
                    cancelReason = "I have less than I need."
                    break;
                default:
                    cancelReason = "Don't want it anymore."
            }

            // vwo event
            window.VWO = window.VWO || [];
            VWO.event = VWO.event || function () {
                VWO.push(["event"].concat([].slice.call(arguments)))
            };
            VWO.event("portalCancellationCompleted");

            // GA4 cancel subscription complete
            gtag('event', 'portal_cancel_subscription_complete');

            // update reason attribute
            await recharge.subscription.cancelSubscription(session, parseInt(currentSubscription.id), {
                cancellation_reason: cancelReason,
                send_email: true,
            });

            // refresh if the modal closes
            document.querySelector('#cancel').addEventListener('close', async function () {
                // refresh
                Swal.fire({
                    title: 'Refreshing',
                    allowOutsideClick: () => !Swal.isLoading()
                });
                Swal.showLoading();
                window.location.reload();
            })
        }

        /**** Resolution screen based on Lookup Table *****/

        // insert the template for the selected reason
        resolution.insertAdjacentHTML("beforeend", cancelTemplates[selectedReason.value]);


        /**** Excessive or insufficient options *****/

        if (selectedReason.value === 'Excess' || selectedReason.value === 'Insufficient') {
            // updates subscription on button click
            document.querySelector(".cancelResolutionUpdate")?.addEventListener("click", async function () {
                // list of updated items
                let updated = [];

                // get product
                let product = products[currentSubscription.external_variant_id.ecommerce];

                // get currently selected variant and cadence
                let variant = document.querySelector(".cancelResolutionModify").value;
                let variantInt = parseInt(variant);
                let cadence = document.querySelector(".cancelResolutionFrequency").value;

                // update object
                let updatePayload = {};

                // check if variant is different
                if (variantInt !== product.variant_id) {
                    // GA4 change variant
                    gtag('event', 'portal_change_variant');

                    updatePayload.use_external_variant_defaults = true;
                    updatePayload.external_variant_id = {
                        ecommerce: variant
                    };
                    updated.push("product");
                }

                // check if frequency is different
                if (parseInt(cadence) !== currentSubscription.order_interval_frequency) {
                    // GA4 change cadence
                    gtag('event', 'portal_change_cadence');

                    updatePayload.order_interval_frequency = cadence;
                    updatePayload.charge_interval_frequency = cadence;
                    updatePayload.order_interval_unit = "week";
                    updated.push("date");
                }

                // no change
                if (Object.keys(updatePayload).length === 0) {
                    await Swal.fire({
                        "icon": "error",
                        "title": "No change detected to your subscription."
                    });
                    return;
                }

                // start loading
                this.classList.add("loading");

                // save old subscription
                let currentNextChargeDate = currentSubscription.next_charge_scheduled_at;

                // update subscription
                currentSubscription = await recharge.subscription.updateSubscription(
                    session,
                    currentSubscription.id,
                    updatePayload
                );

                // check if the next charge date changed
                if (currentNextChargeDate !== currentSubscription.next_charge_scheduled_at) {
                    // ask the user if they want to update the next charge date to the old or new charge date since it changes when you change the frequency
                    let date = await openDeliveryModal(currentNextChargeDate, currentSubscription.next_charge_scheduled_at);

                    // update the charge date if the date is different
                    if (date !== currentSubscription.next_charge_scheduled_at) {
                        currentSubscription = await recharge.subscription.updateSubscriptionChargeDate(session, currentSubscription.id, date);
                    }
                }

                // refresh subscription pricing if the variant changed
                if (variantInt !== product.variant_id) {
                    await refreshSubscriptionPrice(currentSubscription.id);
                }

                // stop loading
                this.classList.remove("loading");

                // close modal
                document.querySelector("#cancel").close();

                // updated subscription
                await Swal.fire({
                    "icon": "success",
                    "title": "Subscription successfully updated!"
                });

                // reload
                window.location.reload()
            })
        }

        /**** Too expensive *****/

        if (selectedReason.value === 'Expensive') {

            // declare variables for if 96 sub exists and if the current subscription is a 32 or 16 pack
            let bulkRolls = false;
            let areRolls = false;

            // check if 96 rolls are already active subscriptions
            subscriptions.forEach(subscription => {
                if (subscription.status === "active") {
                    let variantID = parseInt(subscription.external_variant_id.ecommerce);

                    // check if the variant is a bulk rolls variant
                    if ((rollsVariantsUS[2] === variantID
                        || rollsVariantsCA[2] === variantID)) {
                        bulkRolls = true;
                    }
                }
            })

            // check if the current subscription is a 32 or 16 pack

            let variantSub = parseInt(currentSubscription.external_variant_id.ecommerce);
            if (rollsVariantsUS[0] === variantSub || rollsVariantsCA[0] === variantSub || rollsVariantsUS[1] === variantSub || rollsVariantsCA[1] === variantSub) {
                areRolls = true;
            }

            // country experience
            if (subscriptions.filter(subscription => subscription.status === "active" && subscription.presentment_currency === "CAD").length > 0) {
                countryExperience = "CA";
            }

            // If 96 rolls are already a subscription, or the current subscription isn't a 32 or 16 pack, go to ratings screen
            if (bulkRolls || !areRolls) {
                parent.innerHTML = `${ratePlantPaper()}`;
            }
            // otherwise, show the template for switching to bulk
            else {
                document.querySelector('#cancelResolutionBulk').addEventListener('click', async function () {
                    document.querySelector('#cancelResolutionBulk').classList.add("loading");
                    // add 96 rolls to the subscription

                    // if US
                    if (countryExperience === "US") {
                        await recharge.subscription.updateSubscription(session, currentSubscription.id, {
                            external_variant_id: {
                                ecommerce: `${rollsVariantsUS[2]}` // 96 rolls US
                            }
                        });
                        // if CA
                    } else {
                        await recharge.subscription.updateSubscription(session, currentSubscription.id, {
                            external_variant_id: {
                                ecommerce: `${rollsVariantsCA[2]}` // 96 rolls CA
                            }
                        });
                    }
                    // close modal
                    document.querySelector("#cancel").close();

                    // stop loading
                    this.classList.remove("loading");

                    // success
                    await Swal.fire({
                        icon: "success",
                        title: "Your subscription has been updated to the bulk size.",
                    });

                    // refresh
                    Swal.fire({
                        title: 'Refreshing',
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    Swal.showLoading();
                    window.location.reload();
                })
            }
        }

        /**** Not happy with product *****/

        if (selectedReason.value === 'Performance') {
            // gather options for improvement
            let optionsList = [];
            let totalOptions = 0;
            document.querySelectorAll('.cancelResolutionImproveOption')?.forEach(((option, index) => {
                option.addEventListener('click', async function () {
                    if (option.classList.contains('active')) {
                        option.classList.remove('active');
                        totalOptions >= 1 ? totalOptions-- : "";
                        optionsList.splice(optionsList.indexOf(option.dataset.reason), 1)
                        return;
                    }
                    if (totalOptions !== 3) {
                        option.classList.add('active');
                        optionsList.push(option.dataset.reason)
                        totalOptions++;
                    } else {
                        await Swal.fire({
                            title: "You've selected the max number of options.",
                            target: "#cancel"
                        });
                    }
                })
            }))

            // proceed with cancellation if at least one reason has been provided
            document.querySelector('.cancelResolutionImproveCancel').addEventListener('click', async function () {
                // additional cancel function if has selected reasons
                if (this.classList.contains('cancellation')) {
                    // cancel with provided reasons why
                    await recharge.subscription.cancelSubscription(session, parseInt(currentSubscription.id), {
                        cancellation_reason: "Did not like the way the product performed.",
                        cancellation_reason_comments: optionsList !== null ? optionsList.join(", ") : ""
                        // send_email: true,
                    });

                    // close modal
                    document.querySelector("#cancel").close();

                    // success
                    await Swal.fire({
                        icon: "success",
                        title: "Your subscription has been cancelled successfully.",
                    });

                    window.location.reload();
                }
                // check if we have at least one reason
                else if (totalOptions === 0) {
                    await Swal.fire({
                        title: "Please select at least one reason why you're cancelling.",
                        target: "#cancel"
                    });
                    return;
                }

                // hide the options to update sub
                document.querySelector('#cancelResolutionImprove')?.classList.remove("active");

                // update title and sub button
                document.querySelector('#cancelResolutionTitle').innerHTML = "Got it. We’re working hard to keep improving PlantPaper. We hope you’ll come back and give us another shot. "

                this.innerHTML = "Continue to cancel"
                this.classList.add("cancellation")
            })
        }

        /**** Moving *****/

        if (selectedReason.value === 'Moving') {
            // check if the form exists and if it has been submitted
            if (document.querySelector(".cancelResolutionAddressEditForm")) {
                document.querySelector(".cancelResolutionAddressEditForm").addEventListener("submit", async function (e) {
                    // get current address
                    let address = addresses.filter(address => address.id === currentSubscription.address_id)[0];

                    e.preventDefault();

                    // GA4 update address
                    gtag('event', 'portal_change_address');

                    // save address info
                    let form = Object.fromEntries(new FormData(this));

                    // check if address has changed at all, if not, reject it
                    if (
                        form.first_name.toLowerCase() === address.first_name.toLowerCase() &&
                        form.last_name.toLowerCase() === address.last_name.toLowerCase() &&
                        form.address1.toLowerCase() === address.address1.toLowerCase() &&
                        form.city.toLowerCase() === address.city.toLowerCase() &&
                        form.zip.toLowerCase() === address.zip.toLowerCase() &&
                        form.phone === address.phone
                    ) {
                        await Swal.fire({
                            icon: "error",
                            text: "No changes detected to your address.",
                            target: "#cancel"
                        });
                        return;
                    }

                    // validate address
                    if (form.address1.toLowerCase().includes('po box') || form.address1.includes('PO')) {
                        await Swal.fire({
                            icon: "error",
                            text: "We don't ship to PO Boxes at this time."
                        });
                        return;
                    }

                    // start loading
                    document.querySelector(".cancelResolutionAddressEditForm").classList.add("loading");

                    // address from data
                    let addressForm = Object.fromEntries(new FormData(this));

                    await recharge.address.updateAddress(session, address.id, addressForm);

                    // stop loading
                    this.classList.remove("loading");

                    // close the form
                    document.querySelector('#cancel').close();

                    // reload page
                    await Swal.fire({
                        icon: "success",
                        title: "Your address has been updated successfully.",
                    });

                    // refresh
                    Swal.fire({
                        title: 'Refreshing',
                        allowOutsideClick: () => !Swal.isLoading()
                    });

                    // reload
                    Swal.showLoading();
                    window.location.reload();
                });
            }
        }

        /**** Leaving the country *****/

        if (selectedReason.value === 'Relocating') {

            //setup functionality to skip next shipment
            document.querySelectorAll('.cancelResolutionRelocationSkip')?.forEach(button => {
                button.addEventListener('click', async function (e) {
                    // get the current subscription cadence (weeks)
                    let cadence = currentSubscription.order_interval_frequency;

                    // get the current and most accurate subscription next charge date from the rendered subscription grid item that matches the current subscription
                    let subItem = document.querySelector(`.portalSubscriptionsGridItem[data-id="${currentSubscription.id}"]`);
                    let nextChargeDate = subItem?.querySelector('.portalSubscriptionsGridItemDeliveryModify').value != null
                        ? subItem?.querySelector('.portalSubscriptionsGridItemDeliveryModify').value
                        :
                        currentSubscription.next_charge_scheduled_at;

                    // get the value of times the shipment is being pushed back
                    let pushTimes = this.dataset.value;

                    // push the delivery date back by the cadence and number of times the shipment is being pushed back
                    let newChargeDate = pushDate(nextChargeDate, cadence * 7 * pushTimes);

                    // GA4 skip_next_shipment
                    gtag('event', 'portal_skip_next_shipment');

                    // start loading
                    this.classList.add("loading");

                    // determine the string used for the successful cancel message
                    let cancelMessage = parseInt(pushTimes) === 1
                        ? `Your next shipment has been skipped successfully!`
                        : `Your next ${pushTimes} shipments have been skipped successfully!`;

                    try {
                        // update the subscription by pushing their delivery date back by the current cadence
                        currentSubscription = await recharge.subscription.updateSubscriptionChargeDate(session, currentSubscription.id, newChargeDate);

                        // stop loading
                        this.classList.remove("loading");

                        // success
                        await Swal.fire({
                            icon: "success",
                            title: `${cancelMessage}`,
                            target: "#cancel"
                        });

                        // close the modal
                        document.querySelector("#cancel").close();

                        // refresh
                        Swal.fire({
                            title: 'Refreshing',
                            allowOutsideClick: () => !Swal.isLoading()
                        });

                        // reload
                        Swal.showLoading();
                        window.location.reload();

                    } catch (error) {
                        Swal.fire({
                            icon: "error",
                            title: "There was an error skipping your next shipment.",
                            target: "#cancel"
                        });
                    }

                    // stop loading
                    this.classList.remove("loading");

                })
            })
        }

        // setup functionality for buttons to move to next screen for the delivery date picker
        // 1.) Used for Relocating option
        // 2.) Used for Moving Option

        document.querySelectorAll('.cancelResolutionRelocationPauseNext').forEach(button => {
            button.addEventListener('click', async function () {

                // clear the parent container content for the next screen
                parent.querySelector('#cancelResolutionTitle').innerHTML = `
                    <strong>When do you need your plant paper delivered?</strong>`


                // hide the buttons that aren't the needed buttons
                parent.querySelectorAll('div')?.forEach(item => item.classList.remove('active'));
                parent.querySelectorAll('button')?.forEach(item => item.classList.remove('active'));


                // show the confirm date button and calender
                parent.querySelector('.flatpickr-calendar.inline')?.classList.add('active');
            })
        })

        // make reference to flatpickr calendar for each delivery date button
        // 1.) Used for Relocating option
        // 2.) Used for Moving Option

        let dateButtons = document.querySelectorAll('.cancelResolutionRelocationPause');
        dateButtons.forEach(button => {
            flatpickr(button, {
                inline: true,
                altFormat: "D, F j, Y",
                dateFormat: "Y-m-d",
                defaultDate: currentSubscription.next_charge_scheduled_at,
                disableMobile: true,
                minDate: new Date().fp_incr(1)
            });
        });

        // open date picker
        // 1.) Used for Relocating option
        // 2.) Used for Moving Option

        dateButtons.forEach(button => {
            button.addEventListener("change", async function () {
                // GA4 change_shipment_date
                gtag('event', 'portal_change_shipment_date');

                // start loading
                this.classList.add("loading");

                // update subscription
                currentSubscription = await recharge.subscription.updateSubscriptionChargeDate(session, currentSubscription.id, button.value);

                // stop loading
                this.classList.remove("loading");

                // close the modal
                document.querySelector("#cancel").close();

                // success
                await Swal.fire({
                    icon: "success",
                    title: "Your subscription delivery date has been updated.",
                });

                // refresh
                Swal.fire({
                    title: 'Refreshing',
                    allowOutsideClick: () => !Swal.isLoading()
                });

                // reload
                Swal.showLoading();
                window.location.reload();
            })
        })

        /*** Issues with payment method ***/

        if (selectedReason.value === 'Payment') {
            // add an event listener to the payment button that will find the right subscription item and click the update payment method button
            document.querySelector('.cancelResolutionPayment')?.addEventListener('click', async function () {

                // close modal
                document.querySelector("#cancel").close();

                // find the subscription grid item that matches the current subscription
                let subItem = document.querySelector(`.portalSubscriptionsGridItem[data-id="${currentSubscription.id}"]`);
                subItem?.querySelector('.portalSubscriptionsGridItemPaymentCurrentModify').click();
            })
        }

        /*** Duplicate Subscription ***/

        if (selectedReason.value === 'Duplicate') {
            document.querySelectorAll(".cancelSub").forEach(element => {
                element.addEventListener("click", async function () {
                    await cancelOnClose();
                })
            });
        }

        /*** Trouble Managing Deliveries ***/

        if (selectedReason.value === 'Deliveries') {
            document.querySelector('.cancelResolutionEmail').addEventListener('click', async function () {
                // close modal
                document.querySelector("#cancel").close();
            })
        }

        // add additional flows to prevent cancellation for certain reasons, other reasons just cancel
        // 1.) Flow for Moving option
        // 2.) Flow for Expensive option
        document.querySelector("#cancelResolutionProceed")?.addEventListener("click", async function () {

            // if they're moving and still trying to cancel, offer to change their delivery date instead
            if (selectedReason.value === 'Moving' && !this.classList.contains('cancel')) {
                parent.querySelector('#cancelResolutionTitle').innerHTML =
                    `You can also <strong>change your delivery date</strong>.`

                // hide the buttons that aren't the needed buttons
                parent.querySelectorAll('div')?.forEach(item => item.classList.remove('active'));
                parent.querySelectorAll('button')?.forEach(item => item.classList.remove('active'));

                // show the date buttons
                parent.querySelector('.cancelResolutionRelocationPauseNext')?.classList.add('active');

                // add a class that will determine if the next click will cancel the subscription
                this.classList.add("cancel");
            }

            // if they're trying to cancel after the bulk recommendation, show the ratings screen
            else if (selectedReason.value === 'Expensive' && !this.classList.contains('cancel')) {
                parent.innerHTML = `
                ${ratePlantPaper()}`
            } else {
                await cancelOnClose();
            }
        })
    })

    // close modal backdrop
    document.querySelector("#cancel").addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });

    // close modal buttons
    document.querySelectorAll("#cancelCancel,#cancelExit").forEach(element => element.addEventListener("click", function () {
        document.querySelector("#cancel").close();
    }));


    /****************** Reactivate **************/

    // register dialog
    dialogPolyfill.registerDialog(document.querySelector("#reactivate"));

    // there are two types of reactivation (one with a discount and one without)
    const discountReactivation = sessionStorage.getItem("reactivate") === "10";

    // show reactivation if
    // 1) has "reactivate" in session storage
    // 2) has not already been shown
    // 3) has cancelled subscriptions
    if (
        sessionStorage.getItem("reactivate") &&
        subscriptions.filter(subscription => subscription.status === "cancelled").length > 0
    ) {
        // update copy accordingly
        if (discountReactivation) {
            document.querySelector("#reactivateTitle").innerHTML = "Re-activate your<br> subscription for 10% off.";
            document.querySelector("#reactivateSubtitle").innerHTML = "Which subscription would<br> you like to re-activate?";
        } else {
            document.querySelector("#reactivateTitle").innerHTML = "Which subscription would<br> you like to re-activate?";
            document.querySelector("#reactivateSubtitle").remove()
        }

        // append new subscription options
        subscriptions.forEach(subscription => {
            // find address
            let address = addresses.find(address => address.id === subscription.address_id);

            // only show cancelled subscriptions
            if (subscription.status !== "cancelled") {
                return;
            }

            // cadence and price are only rendered if it's a discount reactivation
            function discountReactivationHTML() {
                if (discountReactivation) {
                    return `
                        <div class="reactivateSubscriptionsItemCadence">Every ${subscription.order_interval_frequency} weeks</div>
                        <div class="reactivateSubscriptionsItemPrice">
                            <span class="reactivateSubscriptionsItemPriceTitle">You'll save $${((subscription.price * 0.10).toFixed(2))}</span>
                            <span class="reactivateSubscriptionsItemPriceCompare">$${subscription.price}</span> 
                            <span class="reactivateSubscriptionsItemPriceRenewal">$${(subscription.price * 0.9).toFixed(2)}</span>
                        </div>
                    `;
                }
                return "";
            }

            // append
            document.querySelector("#reactivateSubscriptions").insertAdjacentHTML("beforeend", `
                <label class="reactivateSubscriptionsItem">
                    <input class="reactivateSubscriptionsItemCheckbox" name="cancel_subscription" type="checkbox" value="${subscription.id}">
                    <div class="reactivateSubscriptionsItemProduct">${subscription.product_title}</div>
                    <div class="reactivateSubscriptionsItemAddress">
                        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path id="795_home 1 (Traced)" fill-rule="evenodd" clip-rule="evenodd" d="M5.2511 5.31248L0.0128082 10.625L0.00642321 10.9783L0 11.3317L1.30147 11.3316H2.60298L2.61267 14.656L2.6224 17.9803H5.90989H9.19739L9.20724 15.9852L9.21708 13.99L10.4994 14.0002L11.7818 14.0104L11.7896 15.9953L11.7974 17.9803L15.0866 17.9902L18.3758 18V14.6649V11.3297L19.6775 11.3327L20.9792 11.3357L20.9896 10.9964L21 10.6571L19.0228 8.65302L17.0456 6.64889V3.64753V0.646176L16.9601 0.669418C16.9131 0.682176 16.3145 0.69289 15.6299 0.69316L14.3852 0.6937V2.32199V3.95033L12.4373 1.97514L10.4894 0L5.2511 5.31248Z" fill="#FF9417"></path> </svg>
                        ${address.address1}
                    </div>
                    ${discountReactivationHTML()}
                </label>
            `)
        });

        // show reactivation
        document.querySelector("#reactivate").showModal();

        // remove session storage
        sessionStorage.removeItem("reactivate");
    }

    // reactivate subscription
    document.querySelector("#reactivateConfirm").addEventListener("click", async function () {
        // get number of selected
        let selectedSubscriptions = document.querySelectorAll(".reactivateSubscriptionsItemCheckbox:checked");

        // check if one is selectedSubscriptions
        if (selectedSubscriptions.length === 0) {
            await Swal.fire({
                title: "Please select a subscription to reactivate.",
                target: "#reactivate"
            });
            return;
        }

        // change active page
        document.querySelector(".reactivatePage.active").classList.remove("active");
        document.querySelectorAll(".reactivatePage")[1].classList.add("active");
    });

    // reactivate - send now
    document.querySelector("#reactivateNow").addEventListener("click", function () {
        // trigger date picker event change since this default date is tomorrow
        document.querySelector("#reactivateCalendarInput").dispatchEvent(new Event("change"));
    });

    // reactivate - send later
    document.querySelector("#reactivateLater").addEventListener("click", function () {
        // change active page
        document.querySelector(".reactivatePage.active").classList.remove("active");
        document.querySelectorAll(".reactivatePage")[2].classList.add("active");
    });

    // reactivate date picker
    flatpickr(document.querySelector("#reactivateCalendarInput"), {
        inline: true,
        altFormat: "D, F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: new Date().fp_incr(1),
        disableMobile: true,
        minDate: new Date().fp_incr(1)
    });

    // on datepicker change, trigger reactivation
    document.querySelector("#reactivateCalendarInput").addEventListener("change", async function () {
        // close modal
        document.querySelector("#reactivate").close();

        // get number of selected
        let selectedSubscriptions = document.querySelectorAll(".reactivateSubscriptionsItemCheckbox:checked");

        // start loading
        Swal.fire({
            title: 'Please Wait',
            allowOutsideClick: () => !Swal.isLoading(),
        });
        Swal.showLoading();

        // loop over each subscription
        for (let i = 0; i < selectedSubscriptions.length; i++) {
            // parse subscription id
            const subscriptionID = parseInt(selectedSubscriptions[i].value);

            // activate subscription
            let subscription = await recharge.subscription.activateSubscription(session, subscriptionID);

            // update subscription billign date
            subscription = await recharge.subscription.updateSubscriptionChargeDate(session, subscription.id, this.value);

            // check if we need to apply the discount
            if (discountReactivation) {
                try {
                    await recharge.address.applyDiscountToAddress(session, subscription.address_id, 'REACTIVATE_10');
                } catch (e) {
                    /*
                    await Swal.fire({
                        "icon": "error",
                        "title": "There was an error applying the discount.",
                        "text": "Please contact info@plantpaper.us with error code P3."
                    });
                     window.location.reload();
                     return;
                     */
                }
            }

        }

        // close modal
        document.querySelector("#reactivate").close();

        // track reactivation
        if (discountReactivation) {
            gtag('event', 'portal_reactivate_subscription_10');
        } else {
            gtag('event', 'portal_reactivate_subscription');
        }

        // success
        await Swal.fire({
            icon: "success",
            title: "Your subscription has been reactivated successfully.",
        });

        // refresh
        Swal.fire({
            title: 'Refreshing',
            allowOutsideClick: () => !Swal.isLoading()
        });
        Swal.showLoading();
        window.location.reload();
    });

    // back button on date picker
    document.querySelector("#reactivateBack").addEventListener("click", function () {
        // change active page
        document.querySelector(".reactivatePage.active").classList.remove("active");
        document.querySelectorAll(".reactivatePage")[1].classList.add("active");
    });

    // close modal backdrop
    document.querySelector("#reactivate").addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
        }
    });

    // close modal buttons
    document.querySelectorAll("#reactivateCancel,#reactivateExit").forEach(element => element.addEventListener("click", function () {
        document.querySelector("#reactivate").close();
    }));

    /**************** Start Portal **********/

    // show portal
    document.querySelector("#loading").classList.remove("active");
    document.querySelector("#intro").classList.add("active");
    document.querySelector("#portal").classList.add("active");
}

setupPortal();


/**************************************************** Confirm Delivery Date Modal ****************************************************/

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#delivery"));

// prevent escape key from closing modal
document.querySelector("#delivery").addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
        e.preventDefault();
    }
});

/**
 * This function is called AFTER a delivery date is updated from changing the frequency of a subscription.
 * We ask the customer which date they want to keep (old or new) and return it
 * Open delivery modal
 * @param {string} oldDate (YYYY-MM-DD)
 * @param {string} newDate (YYYY-MM-DD)
 * @returns The date the customer wants to keep (YYYY-MM-DD)
 */
async function openDeliveryModal(oldDate, newDate) {
    // set date values
    document.querySelector("#deliveryOptionsItemOldValue").value = oldDate;
    document.querySelector("#deliveryOptionsItemNewValue").value = newDate;

    // update date text
    document.querySelector("#deliveryOptionsItemNewDisplay").textContent = dateToString(newDate);

    // open modal
    document.querySelector("#delivery").showModal();

    // wait for customer to select a date
    await new Promise((resolve, reject) => {
        document.querySelector("#deliveryConfirm").addEventListener("click", resolve);
    });

    // close modal
    document.querySelector("#delivery").close();

    // return date
    return document.querySelector(".deliveryOptionsItemCheckbox:checked").value;
}